import * as TK from 'translations/locales/translation-keys.constant';
import {
  ENTER_VALID_ZIP,
  ZIP_SHOULD_BE_VALID,
} from 'utils/pas-control.constants';
import { ResourceLanguage } from 'i18next';
import { common } from 'translations/locales/common';
import { pluralize } from 'translations/utils';

export const locale: ResourceLanguage = {
  translations: {
    ...common,
    'customer_service_page.track_order_email_label_text': 'Email address',
    'customer_service_page.track_order_order_number_label_text': 'Order number',
    'customer_service_page.track_order_order_not_found_error_message':
      'We couldn’t find a record of this order number at this time. Please check the number you entered is correct or try again later. For assistance, please contact',
    'customer_service_page.track_order_email_mismatch_error':
      'We couldn’t match the email address to this order. Please check the address you entered is correct or try again later. For assistance, please contact',
    'customer_service_page.track_order_email_required_error':
      'Email address is required',
    'customer_service_page.track_order_email_valid_error':
      'Enter a valid email address',
    [TK.WE_GOT_AN_ERROR]: 'We got an error. Please try again in a few minutes',
    'pdp.general.error.something_went_wrong':
      'Something went wrong. Please try again in few moments',
    'pdp.main.error.smth_went_wrong':
      'Something went wrong while getting available dates for shipment. Please try again in few moments',
    'pdp.main.error.ship_on_given_date': 'Select another date for delivery',
    'pdp.main.error.store_not_found_for_mode': 'Store is not found for mode',
    'pdp.main.error.no_argument_available_for_catalog':
      'No Arrangement available for catalog: {{catalogNumber}}',
    'pdp.main.error.no_catalog_number_available_for_url':
      'No catalog number available for page friend url: {{pageFriendlyUrl}}',
    'pdp.main.error.no_ingredient_available_for_arrangement':
      'No Ingredients available for arrangementId: {{arrangementId}}',
    'pdp.main.error.no_products_available_for_arrangement':
      'No Products available for arrangementId: {{arrangementId}}',
    'pdp.main.error.no_reviews_available_for_arrangement':
      'No Reviews available for arrangementId: {{arrangementId}}',
    'pdp.main.error.cannot_find_store': 'Cannot find store to process order',
    'pdp.main.error.city_not_found': 'City not found',
    'pdp.main.error.cannot_parse_response': "Can't parse response",
    [ZIP_SHOULD_BE_VALID]: 'Enter a valid zip code',
    [ENTER_VALID_ZIP]: 'Enter a valid zip code to continue',
    'pdp.main.error.provided_zip': 'Zip should be provided',
    'pdp.main.error.provided_date': 'Date should be provided',
    'pdp.main.error.enter_zip_and_date':
      'Enter a zip code and choose a date to continue',
    'pdp.choose_recipient': 'Choose Recipient',
    [TK.RECIPIENT_INFORMATION_ERROR_CAR_MODEL]: 'Enter Car Model',
    [TK.RECIPIENT_INFORMATION_ERROR_CAR_COLOR]: 'Enter Car Color',
    [TK.RECIPIENT_INFORMATION_ERROR_VEHICLE_MODEL]: 'Enter Vehicle Model',
    [TK.RECIPIENT_INFORMATION_ERROR_VEHICLE_COLOR]: 'Enter Vechicle Color',
    [TK.RECIPIENT_INFORMATION_ERROR_CAR_MODEL_SPL_CHARS]:
      'Enter a valid car model',
    [TK.RECIPIENT_INFORMATION_ERROR_CAR_COLOR_SPL_CHARS]:
      'Enter a valid car color',
    [TK.NUMBER_OF_SIZES_ONE]: 'One Size',
    [TK.NUMBER_OF_SIZES_TWO]: 'Two Sizes',
    [TK.NUMBER_OF_SIZES_THREE]: 'Three Sizes',
    [TK.NUMBER_OF_SIZES_FOUR]: 'Four Sizes',
    [TK.NUMBER_OF_SIZES_FIVE]: 'Five Sizes',
    [TK.NUMBER_OF_SIZES_SIX]: 'Six Sizes',
    [TK.NUMBER_OF_SIZES_SEVEN]: 'Seven Sizes',
    [TK.NUMBER_OF_SIZES_EIGHT]: 'Eight Sizes',
    [TK.NUMBER_OF_SIZES_NINE]: 'Nine Sizes',
    [TK.NUMBER_OF_SIZES_TEN]: 'Ten Sizes',
    [TK.NUMBER_OF_SIZES_STARTING_AT]: 'Starting At',
    [TK.NUMBER_OF_SIZES_NUMERIC_QUANTITY]: 'Sizes Starting At',
    [TK.NUMBER_OF_SIZES_NUMERIC_OPTIONS]: 'Options',
    [TK.NUMBER_OF_SIZES_NUMERIC_OPTION]: 'Option',
    [TK.NUMBER_OF_SIZES_NO_SIZES]: 'There are no available sizes',
    [TK.IMAGE_NOT_AVAILABLE]: 'Not available',
    [TK.CLOSE]: 'Close',
    [TK.DAY_OF_WEEK_SUNDAY_LONG]: 'Sunday',
    [TK.DAY_OF_WEEK_MONDAY_LONG]: 'Monday',
    [TK.DAY_OF_WEEK_TUESDAY_LONG]: 'Tuesday',
    [TK.DAY_OF_WEEK_WEDNESDAY_LONG]: 'Wednesday',
    [TK.DAY_OF_WEEK_THURSDAY_LONG]: 'Thursday',
    [TK.DAY_OF_WEEK_FRIDAY_LONG]: 'Friday',
    [TK.DAY_OF_WEEK_SATURDAY_LONG]: 'Saturday',
    [TK.DAY_OF_WEEK_SUNDAY_SHORT]: 'Sun',
    [TK.DAY_OF_WEEK_MONDAY_SHORT]: 'Mon',
    [TK.DAY_OF_WEEK_TUESDAY_SHORT]: 'Tue',
    [TK.DAY_OF_WEEK_WEDNESDAY_SHORT]: 'Wed',
    [TK.DAY_OF_WEEK_THURSDAY_SHORT]: 'Thu',
    [TK.DAY_OF_WEEK_FRIDAY_SHORT]: 'Fri',
    [TK.DAY_OF_WEEK_SATURDAY_SHORT]: 'Sat',
    [TK.HEADER_USER_PROFILE_MENU_SIGN_UP]: 'Sign Up',
    [TK.HEADER_USER_PROFILE_MENU_SIGN_OUT]: 'Sign Out',
    [TK.HEADER_USER_PROFILE_ACCOUNT]: 'Account',
    [TK.HEADER_USER_PROFILE_MY_REWARDS]: 'My Rewards',
    [TK.HEADER_USER_PROFILE_FAQ]: 'FAQs & Benefits',
    [TK.HEADER_USER_PROFILE_MY_INFORMATION]: 'My Information',
    [TK.HEADER_USER_PROFILE_ORDER_HISTORY]: 'Order History',
    [TK.HEADER_USER_PROFILE_GIFT_REMINDERS]: 'Gift Reminders',
    [TK.HEADER_USER_PROFILE_ADDRESS_BOOK]: 'Address Book',
    [TK.HEADER_HELP]: 'Help',
    [TK.HEADER_FIND_STORE]: 'Find a Store',
    [TK.HEADER_EDIBLE_REWARDS]: 'Edible Rewards',
    [TK.HEADER_SHOPPING_CART]: 'Shopping Cart',
    [TK.HEADER_HELP_TRACK_YOUR_ORDER]: 'Track Your Order',
    [TK.HEADER_HELP_CONTACT_US]: 'Contact Us',
    [TK.HEADER_HELP_ALLERGY_SAFETY_INFORMATION]: 'Allergy & Safety Information',
    [TK.HEADER_HELP_PROMOTION_TERMS_CONDITIONS]: 'Promotion Terms & Conditions',
    [TK.HEADER_HELP_CERTIFIED_HAPPINESS]: 'Certified Happiness',
    [TK.HEADER_GET_HELP]: 'Get Help',
    [TK.HEADER_HELP_EDIBLE_GUARANTEE]: 'Edible Guarantee',
    [TK.HEADER_HELP_FAQS]: 'FAQs',
    [TK.HEADER_HELP_PRODUCTS_POLICY]: 'Products Policy',
    [TK.HEADER_STORES_FRANCHISE_OPPORTUNITIES]: 'Franchise Opportunities',
    [TK.HEADER_STORES_EDIBLE_TREATS]: 'Edible® treats',
    [TK.HEADER_ABOUT_WHO_WE_ARE]: 'Who we are',
    [TK.HEADER_ABOUT_OUR_MISSION]: 'Our mission: to wow you®',
    [TK.HEADER_ABOUT_OUR_HISTORY]: 'Our history',
    [TK.HEADER_ABOUT_FOUNDER]: 'Founder, Tariq Farid',
    [TK.HEADER_ABOUT_CONTACT_US]: 'Contact Us',
    [TK.HEADER_OTHER_CAREERS]: 'Careers',
    [TK.HEADER_OTHER_PRESS]: 'Press',
    [TK.HEADER_OTHER_BLOG]: 'Blog',
    [TK.HEADER_NAV_CUSTOMER_SERVICE]: 'Customer Service',
    [TK.HEADER_NAV_STORES]: 'Stores',
    [TK.HEADER_NAV_ABOUT]: 'About',
    [TK.HEADER_NAV_ABOUT_EDIBLE]: 'About Edible Arrangements',
    [TK.HEADER_NAV_OTHER]: 'Other',
    [TK.HEADER_NAV_MENU]: 'Shop By',
    [TK.HEADER_NAV_MORE_LINKS]: 'More Links',
    [TK.HEADER_NAV_LANGUAGE]: 'Select Your Language',
    [TK.SLIDER_NEXT]: 'Next',
    [TK.SLIDER_PREVIOUS]: 'Previous',
    [TK.SUBSCRIPTION_FOOTER_TITLE]:
      'Sign up for promotions and special offers.',
    [TK.SUBSCRIPTION_FOOTER_FORM_EMAIL_LABEL]: 'Email (Required)',
    [TK.SUBSCRIPTION_FOOTER_FORM_SUBMIT]: 'Submit',
    [TK.SUBSCRIPTION_FOOTER_FORM_EMAIL_ERROR]:
      'Please enter a valid email address',
    [TK.SUBSCRIPTION_FOOTER_SIGNUP_FORM_EMAIL_ERROR]: 'Enter a valid email',
    [TK.SUBSCRIPTION_SHOP_NOW]: 'Shop Now',
    [TK.SUBSCRIPTION_TERMS_AND_CONDITIONS_BEFORE]: 'See ',
    [TK.SUBSCRIPTION_TERMS_AND_CONDITIONS_BETWEEN_AND]: 'and',
    [TK.SUBSCRIPTION_EMAIL_FORM_TERMS_AND_CONDITIONS]: 'Terms & Conditions',
    [TK.SUBSCRIPTION_TERMS_AND_CONDITIONS_AFTER]: ' for details.',
    [TK.SUBSCRIPTION_EMAIL_FORM_LABEL]: 'Email (Required)',
    [TK.SUBSCRIPTION_SHOP_NOW]: 'Shop Now',
    [TK.NEW_SUBSCRIPTION_FIRST_POPUP_TITLE]: 'Unlock your discount',
    [TK.NEW_SUBSCRIPTION_FIRST_POPUP_JOIN_EMAIL_TEXT]:
      'Join our email list for ',
    [TK.NEW_SUBSCRIPTION_SIGNUP_FIRST_JOIN_EMAIL_SMS_TEXT]:
      'Join our email or SMS list for ',
    [TK.NEW_SUBSCRIPTION_FIRST_POPUP_INSTANT_SAVINGS_TEXT]: 'instant savings',
    [TK.NEW_SUBSCRIPTION_FIRST_POPUP_INSTANT_TEXT]: 'instant',
    [TK.NEW_SUBSCRIPTION_FIRST_POPUP_SAVINGS_TEXT]: 'savings',
    [TK.NEW_SUBSCRIPTION_FIRST_POPUP_PICKUP_ORDER_TEXT]:
      'on your next pickup order',
    [TK.SUBSCRIPTION_FIRST_POPUP_TITLE]: 'Something You’ll Love!',
    [TK.SUBSCRIPTION_FIRST_POPUP_OFFER_VAL]: '15',
    [TK.SUBSCRIPTION_FIRST_POPUP_OFFER_PER]: '%',
    [TK.VIEW_DETAILS]: 'View Details',
    [TK.HIDE_DETAILS]: 'Hide Details',
    [TK.SUBSCRIPTION_FIRST_POPUP_OFFER_TEXT]: 'off',
    [TK.SUBSCRIPTION_FIRST_POPUP_OFFER_STAR]: '*',
    [TK.SUBSCRIPTION_FIRST_POPUP_DESCRIPTION]:
      'your next pickup order when you sign up to receive our emails today!',
    [TK.SUBSCRIPTION_NEW_SUCCESS_POPUP_TITLE]: 'sweet!',
    [TK.SUBSCRIPTION_SUCCESS_POPUP_DESCRIPTION_FIRST]:
      'Thanks for signing up! Check your email inbox',
    [TK.SUBSCRIPTION_SUCCESS_POPUP_DESCRIPTION_LAST]:
      'for 15% off your next pickup purchase.',
    [TK.SUBSCRIPTION_SUCCESS_POPUP_SOCIAL_LINKS_TITLE]:
      'Connect with us on social media:',
    [TK.SUBSCRIPTION_SUCCESS_POPUP_GIFT_TEXT]:
      'Order a freshly-crafted gift for any occasion!',
    [TK.SUBSCRIPTION_IMAGE_TITLE]:
      'Delicious Fruit design® Dipped Strawberries',
    [TK.SUBSCRIPTION_EMAIL_FORM_BUTTON_LABEL]: 'Sign Up',
    [TK.ERROR_PHONE]: 'Invalid phone number',
    [TK.ERROR_EMAIL]: 'Invalid email',
    [TK.REQUIRED_EMAIL]: 'Email is required',
    [TK.ERROR_AGREE]: 'You must agree to the policy',
    [TK.LOG_IN]: 'Log In',
    [TK.SUBSCRIPTION_TERMS_OF_USE]: 'See Terms of Use',
    [TK.SUBSCRIPTION_FORM_PHONE_LABEL]: 'Phone Number',
    [TK.SUBSCRIPTION_FORM_PHONE_ERROR]: 'Enter a valid phone number',
    [TK.SUBSCRIPTION_FORM_POLICY_LABEL]: 'I agree to the',
    [TK.SUBSCRIPTION_FORM_POLICY_ARIA_LABEL]:
      'I agree to the Terms of Use, Terms & Conditions and Communications Policy',
    [TK.SUBSCRIPTION_FORM_POLICY_TOOLTIP]:
      '¹ By adding your mobile number you agree to receive recurring automated marketing text messages from Edible® at the mobile number provided. Reply HELP for help, and STOP to cancel. Message frequency varies and msg & data rate may apply.',
    [TK.SUBSCRIPTION_FORM_POLICY_TOOLTIP_LABEL]: 'Communications Policy.',
    [TK.SUBSCRIPTION_FORM_POLICY_ERROR]: 'Please check the policy',
    [TK.SUBSCRIPTION_SIGNUP_POLICY_ERROR]: 'Please agree to continue',
    [TK.SOCIAL_LINKS_TITLE]: 'Follow Us',
    [TK.PAYMENT_OPTIONS_TITLE]: 'Secure Payments By',
    [TK.NEAREST_STORE_TITLE]: 'Your Nearest Edible Store',
    [TK.NEAREST_STORE_TODAY_LABEL]: 'Today',
    [TK.NEAREST_STORE_DIRECTIONS_LABEL]: 'Get Directions',
    [TK.TERMS_OF_USE_LABEL]: 'Terms of Use',
    [TK.PRIVACY_POLICY_LABEL]: 'Privacy Policy',
    [TK.PRIVACY_POLICY1_LABEL]: 'Privacy Policy¹',
    [TK.REQUIRED_LABEL]: '(Required)',
    [TK.CALIFORNIA_PRIVACY_RIGHTS_LABEL]: 'California Privacy Rights',
    [TK.CORPORATE_PROMOTION_LABEL]: 'Promotion Terms and Conditions',
    [TK.COOKIE_SETTINGS_LABEL]: 'Your Privacy Choices',
    [TK.CORPORATE_COPYRIGHT_LABEL]:
      'Edible Arrangements, LLC. All rights reserved.',
    [TK.DESKTOP_SEARCH_PLACEHOLDER]: 'Looking for something special?',
    [TK.SEARCH_HELPER_TEXT]: 'Search for products, stores and information...',
    [TK.SEARCH_SUGGESTED_RESULTS]: 'Suggested Results:',
    [TK.SEARCH_NO_SUGGESTIONS]: 'No suggestions found',
    [TK.SEARCHING_TEXT]: 'Searching for suggestions',
    [TK.ALL_RESULTS]: 'All Results',
    [TK.CHOOSE_VARIANT]: 'Choose an Option:',
    [TK.SINGLE_VARIANT]: 'Single Size:',
    [TK.ENTER_ONE_PHONE_NUMBER]: 'Enter a valid phone number',
    [TK.ENTER_ONE_VALID_PHONE_NUMBER]:
      'Please enter a valid home/work/cell phone number.',
    [TK.CANT_BEGIN_WITH_O_OR_1]:
      "Number can't begin with '0' or '1'. Please provide a 10-digit phone number, starting with the area code.",
    [TK.HOME_PAGE_VIEW_ALL]: 'View All',
    [TK.HOME_PAGE_CAROUSEL_FORWARD_CONTROL]:
      'Move carousel forward to revel more products',
    [TK.HOME_PAGE_CAROUSEL_BACKWARDS_CONTROL]:
      'Move carousel backwards to previous products',
    [TK.NEAREST_STORE_WEEKLY_HOURS]: 'Display nearest store weekly hours',
    [TK.NEAREST_STORE_PHONE_CONTACT]:
      'Call the Edible Store closest to your location',
    [TK.NEAREST_STORE_DIRECTIONS]:
      'Get directions to the closest Edible Store to your location',
    [TK.HOME_PAGE_H1_HEADING]:
      'Edible Arrangements Fruit Bouquets, Chocolate Covered Strawberries & Gift Delivery',
    [TK.FRANCHISE_BANNER_TITLE]: 'interested in franchising?',
    [TK.FRANCHISE_BANNER_SUB_TITLE]: "there's an edible for that.",
    [TK.FRANCHISE_BANNER_BODY]:
      'Open your own Edible Arrangements® storefront and join our passionate, global community of franchise owners.',
    [TK.FRANCHISE_BANNER_BUTTON]: 'Learn About Franchising',
    [TK.POPULAR_CATEGORIES]: 'Popular Categories',
    [TK.EDIBLE_GUARANTEE_TITLE]: 'edible guarantee',
    [TK.EDIBLE_GUARANTEE_DESCRIPTION]:
      'We’re here for you. For life’s big moments, the just-because, and even when things don’t go according to plan. That’s why we’re devoted to the Edible Guarantee – our promise to give our best.',
    [TK.EDIBLE_GUARANTEE_POLICY]:
      'Your happiness is our happiness, and it’s 100% guaranteed.',
    [TK.EDIBLE_GUARANTEE_HASSLEFREE]: 'guaranteed satisfaction, hassle-free',
    [TK.EDIBLE_GUARANTEE_SATISFACTION_HEADER]: 'satisfaction',
    [TK.EDIBLE_GUARANTEE_SUPPORT_HEADER]: 'guarantee',
    [TK.EDIBLE_GUARANTEE_STREAMLINED_HEADER]: 'streamlined',
    [TK.EDIBLE_GUARANTEE_SATISFACTION]:
      'We will replace or refund your order if you aren’t 100% satisfied.',
    [TK.EDIBLE_GUARANTEE_SUPPORT]: 'Hassle-free support via email, or phone.',
    [TK.EDIBLE_GUARANTEE_STREAMLINED]:
      'We take your happiness seriously! Tell us how we did.',
    [TK.ALERT_OWN_BOX_ADDONS]: 'Please select at least 1 item',
    [TK.ALERT_PRODUCT_OPTION]: 'Please, select an option',
    [TK.ALERT_AVAILABILITY_ZIP]: 'Please enter ZIP Code to Continue',
    [TK.ALERT_AVAILABILITY_DATE]: 'Please select Date to Continue',
    [TK.ALERT_AVAILABILITY_DELIVERY_METHOD]:
      'Please select Fulfillment Type to Continue',
    [TK.ALERT_AVAILABILITY_STORE]: 'Please select the Store to Continue',
    [TK.ALERT_SUGGESTED_DATE]:
      'Please select a suggested date to continue with your order',
    [TK.ALERT_SUGGESTED_PRODUCT]:
      'Please choose from suggested products to continue with shopping',
    [TK.ALERT_DESSERT_OWN_BOX_ADDONS]:
      'Please select at least 1 item from each of the 3 options below to continue.',
    [TK.ALERT_6_COOKIE_BOX_ADDONS]:
      'Please select at least 1 cookie to continue.',
    [TK.ALERT_12_COOKIE_BOX_ADDONS]:
      'Please select at least 1 cookie from the first list below to continue.',
    [TK.ALERT_CUPCAKE_ADDONS]: 'Please select at least 1 cupcake to continue.',
    [TK.ALERT_WRAP_ADDONS]: 'Please select at least 1 wrap to continue.',
    [TK.PDP_TITLE]: 'Make A Selection',
    [TK.PICKUP]: 'Pickup for {{name}} on {{date}}',
    [TK.MENU_TITLE]: 'Select Recipient',
    [TK.GUIDE]:
      'You can add a new recipient below or continue shopping for {{name}}',
    [TK.NEW_RECIPIENT_SUBTITLE]: 'Different address or date',
    [TK.SWITCH_RECIPIENT]: 'Switch recipient',
    [TK.DELIVERY_FROM]:
      'Your order will be serviced from {{store}} on {{date}}',
    [TK.DELIVERY_FOR]: 'Delivery to {{name}} on {{date}}',
    [TK.PICKUP_FROM]:
      'Your order will be ready for pickup from {{store}} on {{date}} at {{time}}',
    [TK.PICKUP_FOR]: 'Pickup for {{name}} on {{date}}',
    [TK.SHIPMENT_SERVICED_ON]: 'Your order will be serviced on {{date}}',
    [TK.NEW_RECIPIENT]: 'New Recipient',
    [TK.DELIVERY]: 'Delivery',
    [TK.PICK_UP]: 'Pick Up',
    [TK.DELIVERY_DESCRIPTION]:
      'What could be sweeter than hand delivery? Treats that arrive fresh with picture-perfect presentation, of course. With Edible® delivery, that’s just standard.',
    [TK.AVAILABLE_FOR_OTHER_DATES]: 'Available for other dates',
    [TK.CHOOSE_ANOTHER_DATE]: 'Select another date for pickup',
    [TK.AVAILABLE_FOR_OTHER_PRODUCTS]: 'Available for other products',
    [TK.CHANGE_DELIVERY_STORE]:
      'We’ve selected a local store for your delivery based on availability.',
    [TK.CHANGE_STORE]: 'Change Store',
    [TK.OTHER_PRODUCTS_AVAILABLE]:
      'We’re sorry, but this product is not available on the date you selected. Please choose another product available on your selected date.',
    [TK.DELIVERY_NOT_AVAILABLE_FOR_DATE_SUGGEST_DATES]:
      'Sorry! Delivery is unavailable for the selected date. Click to view available dates.',
    [TK.DELIVERY_NOT_AVAILABLE_FOR_DATE_SUGGEST_PRODUCTS]:
      'Sorry! Delivery is unavailable for the selected product. Click to see other products which are available for delivery for the selected date.',
    [TK.PICKUP_NOT_AVAILABLE_FOR_DATE_SUGGEST_DATES]:
      'Sorry! Pick up is unavailable for the selected date. Click to view available dates.',
    [TK.PICKUP_NOT_AVAILABLE_FOR_DATE_SUGGEST_PRODUCTS]:
      'Sorry! The product you selected is not available for in-store pick up. See if there’s something sweet you’d rather grab!',
    [TK.PICKUP_IN_STORE]: 'Pick Up In Store',
    [TK.PICKUP_DESCRIPTION]:
      "Stores nationwide for fast, convenient pickup that's always",
    [TK.FREE]: 'FREE',
    [TK.NO_APPROPRIATE_DATE]: 'Not seeing the date you’d like?',
    [TK.EXPLORE_AVAILABLE_PRODUCTS]:
      'Let’s explore available products on your selected date.',
    [TK.SEE_AVAILABLE_PRODUCTS]: 'See Available Products',
    [TK.FLEX_FREE]: 'FREE*',
    [TK.FLEX_NEXT_DAY_PRICE]: '$5.99*',
    [TK.FLEX_NEXT_DAY_PRICE_CA]: '$9.99*',
    [TK.FLEX_DATES_AVAILABLE]: 'Flex Dates Available',
    [TK.FLEX_DELIVERY_DATES]: 'Flexible with Delivery Date?',
    [TK.FLEX_DELIVERY_DATES_SUBTITLE]:
      'We offer free delivery for most next day and beyond delivery orders.',
    [TK.FLEX_DATES_AVAILABLE_SUBTITLE]:
      'We’ve found additional delivery dates you might be interested in. Happy with your selected date? Just skip this selection.',
    [TK.CHOOSE_ANOTHER_DATE]: 'Select another date for delivery',
    [TK.DISCLAIMER_MESSAGE]:
      '*Additional surcharges may incur for Delivery that exceeds 15 miles and/or for Same Day or 1 Hour Delivery orders based on the time zone of the store receiving the order. See Terms of Use for more details',
    [TK.DISCLAIMER_MESSAGE_KMS]:
      '*Additional surcharges may incur for Delivery that exceeds 24 kilometers and/or for Same Day or 1 Hour Delivery orders based on the time zone of the store receiving the order. See Terms of Use for more details',
    [TK.CURBSIDE]: 'Curbside',
    [TK.DISTANCE]: 'distance',
    [TK.KOSHER]: 'Kosher',
    [TK.MILES]: '~{{miles}} miles',
    [TK.KILOMETERS]: '~{{km}} km',
    [TK.KILOMETERS_TEXT]: 'Kilometers',
    [TK.SMOOTHIE]: 'Smoothie',
    [TK.TITLE_PICKUP]: 'Select local pickup shop',
    [TK.TITLE_DELIVERY]: 'Select shop for delivery',
    [pluralize(TK.SHOW_MORE)]: 'Show {{count}} More',
    [TK.VIEW_MORE]: 'View More',
    [TK.MONDAY_FULL]: 'Monday',
    [TK.TUESDAY_FULL]: 'Tuesday',
    [TK.WEDNESDAY_FULL]: 'Wednesday',
    [TK.THURSDAY_FULL]: 'Thursday',
    [TK.FRIDAY_FULL]: 'Friday',
    [TK.SATURDAY_FULL]: 'Saturday',
    [TK.SUNDAY_FULL]: 'Sunday',
    [TK.MONDAY_SHORT]: 'Mon',
    [TK.TUESDAY_SHORT]: 'Tue',
    [TK.WEDNESDAY_SHORT]: 'Wed',
    [TK.THURSDAY_SHORT]: 'Thu',
    [TK.FRIDAY_SHORT]: 'Fri',
    [TK.SATURDAY_SHORT]: 'Sat',
    [TK.SUNDAY_SHORT]: 'Sun',
    [TK.ERROR_NO_STORES]:
      'Oops, we can not suggest you any of our store at the moment. Please select another date or change the fulfillment method.',
    [TK.ERROR_DELIVERY_CUTOFF_PASSED]:
      'Oops, the delivery cutoff time has passed for today. Please select another date.',
    [TK.ERROR_PICKUP_CUTOFF_PASSED]:
      'Oops, the pickup cutoff time has passed for today. Please select another date.',
    [TK.ERROR_PICKUP_DATE_IN_PAST]:
      'Oops, the pickup date may not be in the past. Please select another date.',
    [TK.ERROR_SAME_DAY_SHIPMENT]:
      'Oops, we currently do not offer same day shipping, please select another date.',
    [TK.ERROR_NEXT_DAY_SHIPMENT_CUTOFF_PASSED]:
      'Oops, Next Day shipment is no longer available today, please select another date.',
    [TK.ERROR_SIZE_IS_NOT_AVAILABLE]:
      "We're sorry, the option you selected is not available at this store. Please select a different size or date.",
    [TK.ERROR_STORE_IS_CLOSED]:
      "We're sorry, this store is currently closed. Please select another zip or date.",
    [TK.ERROR_PICKUP_CUTOFF_DATE]:
      "We're sorry but the store you’ve selected does not accept same day pickup orders after {{time}}. Please select a different date or another store.",
    [TK.ERROR_BEFORE_MINIMUM_PICKUP_TIME]:
      'Oops, the pickup time selected is not available. Please choose a time after {{time}} or contact the store.',
    [TK.ERROR_SERVICING_STORE_CLOSED]:
      "We're sorry but the store you’ve selected is closed on {{date}}. Please select another date.",
    [TK.ERROR_SERVICING_STORE_CANNOT_FULFILL_ORDER]:
      "We're sorry but the store you’ve selected cannot complete the order for {{date}}. Please select another date.",
    [TK.ERROR_DELIVERY_IS_NOT_AVAILABLE_FOR_STORE_ON_DATE]:
      "We're sorry, delivery is currently not available on {{date}} from the store you selected {{store}}. Please select another date.",
    [TK.ERROR_PICKUP_IS_NOT_AVAILABLE_FOR_STORE_ON_DATE]:
      "We're sorry, pick up is currently not available on {{date}} from the store you selected {{store}}. Please selected another date.",
    [TK.ERROR_NO_STORES]:
      'Oops, we can not suggest you any of our store at the moment. Please select another date or change the fulfillment method.',
    [TK.ERROR_DELIVERY_CUTOFF_PASSED]:
      'Oops, the delivery cutoff time has passed for today. Please select another date.',
    [TK.ERROR_PICKUP_CUTOFF_PASSED]:
      'Oops, the pickup cutoff time has passed for today. Please select another date.',
    [TK.ERROR_PICKUP_DATE_IN_PAST]:
      'Oops, the pickup date may not be in the past. Please select another date.',
    [TK.ERROR_SAME_DAY_SHIPMENT]:
      'Oops, we currently do not offer same day shipping, please select another date.',
    [TK.ERROR_NEXT_DAY_SHIPMENT_CUTOFF_PASSED]:
      'Oops, Next Day shipment is no longer available today, please select another date.',
    [TK.ERROR_SIZE_IS_NOT_AVAILABLE]:
      "We're sorry, the option you selected is not available at this store. Please select a different size or date.",
    [TK.ERROR_STORE_IS_CLOSED]:
      "We're sorry, this store is currently closed. Please select another zip or date.",
    [TK.ERROR_PICKUP_CUTOFF_DATE]:
      "We're sorry but the store you’ve selected does not accept same day pickup orders after {{time}}. Please select a different date or another store.",
    [TK.ERROR_BEFORE_MINIMUM_PICKUP_TIME]:
      'Oops, the pickup time selected is not available. Please choose a time after {{time}} or contact the store.',
    [TK.ERROR_SERVICING_STORE_CLOSED]:
      "We're sorry but the store you’ve selected is closed on {{date}}. Please select another date.",
    [TK.ERROR_SERVICING_STORE_CANNOT_FULFILL_ORDER]:
      "We're sorry but the store you’ve selected cannot complete the order for {{date}}. Please select another date.",
    [TK.ERROR_DELIVERY_IS_NOT_AVAILABLE_FOR_STORE_ON_DATE]:
      "We're sorry, delivery is currently not available on {{date}} from the store you selected {{store}}. Please select another date.",
    [TK.ERROR_PICKUP_IS_NOT_AVAILABLE_FOR_STORE_ON_DATE]:
      "We're sorry, pick up is currently not available on {{date}} from the store you selected {{store}}. Please selected another date.",
    [TK.SHOW_MORE_REVIEW]: 'Show {{count}} More Review',
    [pluralize(TK.SHOW_MORE_REVIEW)]: 'Show {{count}} More Reviews',
    [TK.PRODUCT_NO_REVIEW]: 'No Reviews',
    [TK.PRODUCT_REVIEW]: 'Review: {{count}}',
    [pluralize(TK.PRODUCT_REVIEW)]: 'Reviews: {{count}}',
    [TK.PRODUCT_REVIEWS]: 'Reviews',
    [TK.PRODUCT_DESCRIPTION]: 'About',
    [TK.PRODUCT_DETAILS]: 'Details',
    [TK.NO_BRAND_DESCRIPTION]:
      'Our curated selection from {{brand}} will help you find the perfect gift.',
    [TK.PRODUCT_INGREDIENTS]: 'Ingredients',
    [TK.QUESTIONS]: 'Questions? Ask Away!',
    [TK.COUPONS_APPLICABLE_TITLE]: 'Coupons Not Applicable',
    [TK.FLAVORS_BREAKDOWN_WARNING]:
      '<b>Allergen Warning</b>: Edible Arrangements® products contain, or may have come in contact with, tree nuts (almonds, hazelnuts, coconuts, and pistachios), peanuts, wheat, eggs, milk, and soy. We cannot promise that a gift will not have come in contact with nuts, nut oil, or another allergen. We recommend that you take the necessary precautions based on any related allergies.',
    [TK.FLAVORS_BREAKDOWN_VIEW_MORE]: 'View More',
    [TK.FLAVORS_BREAKDOWN_VIEW_LESS]: 'View Less',
    [TK.ALLERGY_WARNING_TITLE]: 'Allergy Warning: ',
    [TK.DISCLAIMER_TITLE]: 'Disclaimer: ',
    [TK.INGREDIENT_ALLERY_LINK]: 'Ingredients & Allergy Info ',
    [TK.FAQ_LINK]: 'FAQ',
    [TK.SHOW_MORE_DELIVERY_STORES]: 'Show More Delivery Stores',
    [TK.WHEN]: 'When?',
    [TK.TODAY]: 'Today ({{date}})',
    [TK.TOMORROW]: 'Tomorrow ({{date}})',
    [TK.DATE_SELECTION]: 'Date selection options',
    [TK.DATE_CALENDAR_PICKER]: 'Calendar date picker',
    [TK.DATE_PICKER]: 'Select Date',
    [TK.UPSELLS_DECREASE_QUANTITY]: 'Decrease quantity',
    [TK.UPSELLS_INCREASE_QUANTITY]: 'Increase quantity',
    [TK.UPSELLS_REMOVE]: 'Remove',
    [TK.UPSELLS_ADD]: 'Add',
    [TK.UPSELLS_CONTINUE]: 'Continue',
    [TK.UPSELLS_SAVE_SELECTION]: 'Save selections ({{count}})',
    [TK.UPSELLS_TITLE]: 'upgrade your gift',
    [TK.UPSELLS_OPTIONS_SINGLE]: 'Single',
    [TK.UPSELLS_OPTIONS_OPTION]: 'Option',
    [TK.UPSELL_OPTIONS_STARTING_AT]: 'Options Starting At',
    [TK.UPSELL_OPTIONS_SHOW_ALL]: 'Show all',
    [TK.UPSELL_OPTIONS_EXPANDED_SINGLE]: 'Single Option',
    [TK.UPSELL_OPTIONS_EXPANDED_SELECT_ONE]: 'Select Only One Option',
    [TK.UPSELL_OPTIONS_EXPANDED_SELECT_MULTIPLE]: 'Select 1–{{count}} Options',
    [TK.UPSELL_OPTIONS_EXPANDED_SHOW_LESS]: 'Show less',
    [TK.UPSELL_OPTIONS_WARNING]:
      'Warning: We cant fetch the upsells, just go to the recipient form',
    [TK.UPSELL_OPTIONS_WARNING_DESIGN_VARY]: 'Design may vary',
    [TK.UPSELL_OPTIONS_NOTICE]:
      'Notice: There is no upsells here. You should go to the recipient form',
    [TK.UPSELL_SHOW_MORE]: 'Show More',
    [TK.UPSELL_SHOWING]: 'Showing {{shown}} of {{count}}.',
    [TK.UPSELL_SHOW]: 'Show {{shownCount}} More',
    [TK.UPSELL_OPTIONS_PRODUCT_BADGE_LABEL]: 'Your gift',
    [TK.SAVE]: 'Save',
    [TK.ADD]: 'Add',
    [TK.CANCEL]: 'Cancel',
    [TK.LETTERS_OPTION_TITLE]: 'Letter (1–5 chars)',
    [TK.LETTERS_OPTION_MODAL_TITLE]: 'Letter',
    [TK.LETTERS_OPTION_EXAMPLE]: 'Example: Birthday — add their name',
    [TK.LETTERS_OPTION_WARN]: 'Only upper case letters are allowed',
    [TK.LETTERS_INPUT_LABEL]: 'Enter Letters',
    [TK.NUMBERS_OPTION_TITLE]: 'Number (1–3 chars)',
    [TK.NUMBERS_OPTION_MODAL_TITLE]: 'Number',
    [TK.NUMBERS_OPTION_EXAMPLE]: "Example: Sweet Sixteen - add a '16'",
    [TK.NUMBERS_OPTION_WARN]: 'Only numbers are allowed',
    [TK.NUMBERS_INPUT_LABEL]: 'Enter Your Number',
    [TK.YEAR_OPTION_TITLE]: 'Year (4 chars)',
    [TK.YEAR_OPTION_MODAL_TITLE]: 'Year',
    [TK.YEAR_OPTION_EXAMPLE]:
      'Example: Class Reunion — type the graduation year (YYYY)',
    [TK.YEAR_OPTION_WARN]: 'Only numbers are allowed',
    [TK.YEAR_INPUT_LABEL]: 'Enter Year',
    [TK.EMPTY_VALUE_VALIDATION_ERROR_MESSAGE]:
      'Enter at least one character to continue',
    [TK.CENSORED_WORD_VALIDATION_ERROR_MESSAGE]:
      'This combination of letters is prohibited. Please try another combination',
    [TK.SWITCH_TO_THIS_OPTION]: 'Switch to This Option',
    [TK.MAXIMUM_3_CHARACTERS]: 'Maximum 3 characters.',
    [TK.MAXIMUM_5_CHARACTERS]: 'Maximum 5 characters.',
    [TK.ONLY_NUMBERS_ALLOWED]: 'Only numbers are allowed.',
    [TK.MUST_BE_4_CHARACTERS_LONG]: 'Must be 4 characters long.',
    [TK.ONLY_UPPERCASE_LETTERS_ALLOWED]: 'Only upper case letters are allowed.',
    [TK.PDP_RECIPIENT_NAME]: 'Recipient contact information',
    [TK.PDP_REQUIRED_FIELD]: '* Required field',
    [TK.PDP_FIRST_NAME_PLACEHOLDER]: 'First Name*',
    [TK.PDP_FIRST_NAME_TEXT]: 'The recipient is the one RECEIVING this item',
    [TK.PDP_FIRST_NAME_TEXT_PICKUP]: 'The recipient is the one PICKING UP',
    [TK.PDP_LAST_NAME_PLACEHOLDER]: 'Last Name*',
    [TK.PDP_ADDRESS_TITLE]: 'Recipient address',
    [TK.PDP_ADDRESS_SUBTITLE]:
      'Select Residential or Business for your address type, then enter details.',
    [TK.PDP_ADDRESS_TYPE_LABEL]: 'Address Type*',
    [TK.PDP_ADDRESS_TYPE_RESIDENCE_TITLE]: 'Residence',
    [TK.PDP_ADDRESS_TYPE_RESIDENCE_SUBTITLE]:
      'We deliver to residences during our regular delivery window.',
    [TK.PDP_ADDRESS_TYPE_BUSINESS_TITLE]: 'Business',
    [TK.PDP_ADDRESS_TYPE_BUSINESS_SUBTITLE]:
      'We deliver to businesses during their regular operating hours.',
    [TK.PDP_ADDRESS_TYPE_ERROR]:
      'To continue, select the address type above that matches your gift’s destination.',
    [TK.PDP_BUSINESS_NAME_LABEL]: '{{type}} Name*',
    [TK.PDP_CITY_LABEL]: 'City / Town*',
    [TK.PDP_PO_BOX_NOTE]: 'We cannot deliver to P.O. Boxes.',
    [TK.PDP_STREET_ADDRESS]: 'Street Address*',
    [TK.PDP_APT_FLOOR_SUITE_BUTTON]: 'Apt/Floor/Suite',
    [TK.PDP_APT_FLOOR_SUITE_LABEL]: 'Apt/Floor/Suite',
    [TK.PDP_PICKUP_TIME]: 'Pickup Time',
    [TK.PDP_CHOOSE_OPTION]: 'Please Choose',
    [TK.PDP_BUSINESS_WARNING]:
      'We do not advise same day business deliveries to be placed after 3:00 PM as many businesses close at 5:00 PM. Your local store may contact you if you place a same day order for delivery to reschedule your order for another business day.',
    [TK.PDP_ENTER_FIRST_NAME]: 'Enter first name.',
    [TK.PDP_ENTER_LAST_NAME]: 'Enter last name.',
    [TK.PDP_ERROR_ALERT_ADD_TO_CART_HEADING]: 'Whoops a daisy!',
    [TK.PDP_ERROR_ALERT_ADD_TO_CART_BODY]:
      "We're having trouble adding this item to the cart. Please try again in a few minutes.",
    [TK.PDP_ERROR_PICKUP_IN_PAST]:
      'Oops, the pickup date may not be in the past. Please select another date.',
    [TK.PDP_ERROR_CHOOSE_SAME_DAY_PICKUP_TIME_AFTER]:
      'We’re sorry but store {{store}} does not accept same-day pickup orders after {{time}}. Please select a different date.',
    [TK.PDP_ERROR_CHOOSE_PICKUP_TIME_AFTER]:
      'Oops, the pickup time selected is not available. Please choose a time after {{time}} or contact the store.',
    [TK.ERROR_SAME_DAY_SHIPMENT]:
      'Oops, we currently do not offer same-day shipping, please select another date.',
    [TK.PDP_ERROR_NEXT_DAY_SHIPMENT_CUTOFF]:
      'Oops, the next-day shipment is no longer available today, please select another date.',
    [TK.PDP_ERROR_NO_SERVICE_OPTION]:
      'Oops, we are unable to process your selection. Please refresh the page.',
    [TK.PDP_ERROR_SERVICE_OPTION_STORE]:
      'We are sorry, the product size that you selected is not available at this store. Please select a different size or store.',
    [TK.PDP_ERROR_ORDER_DATE_IN_PAST]:
      'The order date is in the past and is no longer available. Please select another date.',
    [TK.PDP_ERROR_STORE_IS_CLOSED_ON_DATE]:
      'We’re sorry but the store you’ve selected is closed on this day. Please select another date.',
    [TK.PDP_ERROR_STORE_CANNOT_FULFILL_ON_DATE]:
      'We’re sorry but the store you’ve selected cannot complete the order on {{date}}. Please select another date.',
    [TK.ERROR_STORE_IS_CLOSED]:
      'We’re sorry but the store you’ve selected is closed on this day. Please select another date.',
    [TK.PDP_ERROR_DELIVERY_NOT_AVAILABLE_ON_DATE_FOR_STORE]:
      'We’re sorry, delivery is currently not available on {{date}} from the store you selected {{store}}. Please select another date.',
    [TK.PDP_ERROR_PICKUP_NOT_AVAILABLE_ON_DATE_FOR_STORE]:
      'We’re sorry, pick up is currently not available on {{date}} from the store you selected {{store}}. Please selected another date.',
    [TK.PDP_ERROR_UNCOMPLETED_REQUIRED_FIELDS]:
      'Please complete all required fields: {{fields}}',
    [TK.PDP_ERROR_FIRST_NAME_SPL_CHARS]: 'Enter a valid first name',
    [TK.PDP_ERROR_LAST_NAME_SPL_CHARS]: 'Enter a valid last name',
    [TK.PDP_ERROR_STREET_ADDRESS_SPL_CHARS]: 'Enter a valid street address.',
    [TK.PDP_ERROR_REQUIRED]: 'required',
    [TK.PDP_ERROR_NAME_SPL_CHARS]: 'Enter a valid name or send anonymously',
    [TK.PDP_ERROR_OCCASION_ID]: 'Select an occasion',
    [TK.PICKUP_FORM_IDENTIFICATION]: 'Identification',
    [TK.FIRST_NAME_PLACEHOLDER]: 'Recipient First Name*',
    [TK.LAST_NAME_PLACEHOLDER]: 'Recipient Last Name*',
    [TK.PICKUP_PHONE_LABEL]: 'Pickup Phone Number',
    [TK.PICKUP_PHONE]: 'Recipient Phone*',
    [TK.PICKUP_DATE_TIME_HEADER]: 'Date & Time',
    [TK.PICKUP_DATE_TIME_LABEL]: 'Pickup Time *',
    [TK.PICKUP_DATE_TIME_ALERT_ON]: 'Pickup On:',
    [TK.PICKUP_DATE_TIME_ALERT_DATE]: 'Pickup Date:',
    [TK.PICKUP_FORM_CURBSIDE_SWITCH_LABEL]: 'Curbside Pickup',
    [TK.PICKUP_CURBSIDE_MODEL_LABEL]: 'Vehicle Model*',
    [TK.PICKUP_CURBSIDE_COLOR_LABEL]: 'Vehicle Color*',

    [TK.PICKUP_INSTRUCTIONS]: 'Pickup Instructions',
    [TK.PICKUP_INSTRUCTION_BUTTON]: 'Pickup Instructions',
    [TK.PICKUP_INSTRUCTIONS_HEADER]: 'Pickup Instructions',
    [TK.PICKUP_INSTRUCTIONS_LABEL]: 'Provide Pickup Instructions.',
    [TK.PICKUP_INSTRUCTIONS_PLACEHOLDER]:
      'Write your pickup instructions here.',
    [TK.PICKUP_INSTRUCTIONS_HELPER_TEXT]:
      'Provide details to make your pickup as convenient as possible. (Ex: pickup timeframe, accessibility requirements, etc.)',
    [TK.PICKUP_DETAILS]: 'Pickup Details',
    [TK.PICKUP_CONTACT_DETAILS]: 'We only reach out if there are complications',
    [TK.READ_OUR_DELIVERY_POLICIES]: 'Read our Delivery Policies',

    [TK.DELIVERY_INSTRUCTIONS]: 'Delivery Instructions',
    [TK.DELIVERY_INSTRUCTIONS_HELPER_TEXT]:
      'Provide details to help us deliver your treats to the right place. (Ex: crossroads, landmarks, info for gated communities, etc.)',
    [TK.DELIVERY_INSTRUCTIONS_PLACEHOLDER]:
      'Write your delivery instructions here.',
    [TK.DELIVERY_INSTRUCTIONS_LABEL]: 'Provide Delivery Instructions.',

    [TK.PICKUP_DATETIME]: 'Date & Time',
    [TK.COMPLIMENTARY_GIFT_MESSAGE]: 'Add a Сomplimentary Gift Message',
    [TK.COMPLIMENTARY_MESSAGE_TITLE]: 'Сomplimentary Gift Message',
    [TK.OR]: 'Or',
    [TK.REMOVE_GIFT_MESSAGE]: 'Remove Gift Message',
    [TK.GIFT_MESSAGE_FREE_EXPLAIN]:
      'Write a gift message, and include your name so the recipient knows who sent their gift.',
    [TK.HEARTFELT_MESSAGE]: 'Leave them a heartfelt message',
    [TK.TOP_PICK]: 'TOP PICK',
    [TK.PREMIUM_CARD]: 'Add Card',
    [TK.OPTIONAL]: 'optional',
    [TK.SELECT_NEW_CARD]: 'Select New Card',
    [TK.REMOVE_CARD]: 'Remove Card',
    [TK.GIFT_MESSAGE_FREE_HINT]:
      'Our treats will make an impression, but your card can be a keepsake they cherish for years to come.',
    [TK.ENTER_CARD_MESSAGE]: 'Write Your Gift Message.',
    [TK.GIFT_MESSAGE_EDIT_LABEL]: 'Edit Your Gift Message.',
    [TK.GIFT_MESSAGE_EDIT_PLACEHOLDER]: 'Write your gift message here.',
    [TK.PRINTIBLE_CARD_PREVIEW]: 'Card preview',
    [TK.PRINTIBLE_APP]: 'Printible App',
    [TK.PRINTIBLE_IFRAME_ERROR]:
      'Browser Support Error: Browser Does Not Support iframe.',
    [TK.PRINTIBLE_SUBTITLE]:
      'Pick a card you love, or <strong>add your own photo</strong> to <strong>your heartfelt message</strong>',
    [TK.PRINTIBLE_OLD_PRICE_TEXT]: 'Was ',
    [TK.PRINTIBLE_PRICE_SUBTEXT]: 'Only ',
    // eslint-disable-next-line no-template-curly-in-string
    [TK.PRINTIBLE_PRICE_TEXT]: '${{price}}',
    [TK.COMPLIMENTARY_CARD]: 'Complimentary card',
    [TK.PRINTIBLE_CARDS]: 'Printible cards',
    [TK.GIFT_CARD_MODAL_TITLE]: 'Leave Them A Heartfelt Message',
    [TK.GIFT_CARD_MODAL_SUB_TITLE]:
      'Remember to include your name! Your message is the only way the recipient will know who sent their gift.',
    [TK.GIFT_CARD_MODAL_GIFT_MESSAGE]: 'Make it Memorable',
    [TK.GIFT_CARD_MODAL_KEEPSAKE_CHERISH]: 'send a personalized greeting card',
    [TK.GIFT_CARD_MODAL_YEAR_COME]: 'for Years to Come',
    [TK.WRITE_FOR_ME_NAME]: 'Your Name*',
    [TK.ANANYMOUSLY_SWITCH_LABEL]: 'Send anonymously',
    [TK.WRITE_FOR_ME_NAME_NOTE]: 'Let the recipient know who sent their gift',
    [TK.WRITE_FOR_ME_CREATE_BUTTON]: 'Create My Gift Message',
    [TK.WRITE_FOR_ME_START_NEW_BUTTON]: 'Start A New Gift Message',
    [TK.GIFT_MESSAGE_TABS_LABEL]: 'Card message input type tabs',
    [TK.GIFT_MESSAGE_FIRST_TAB_LABEL]: 'Write My Own',
    [TK.GIFT_MESSAGE_SECOND_TAB_LABEL]: 'Write For Me',
    [TK.ALERT_OWN_BOX_ADDONS]: 'Please select at least 1 item',
    [TK.TITLE]: 'Make A Selection',
    [TK.AREA]: 'Zip Code',
    [TK.POSTAL_CODE]: 'Postal Code',
    [TK.STATE]: 'State',
    [TK.PROVINCE]: 'Province',
    [TK.CITY]: 'City/Town',
    [TK.CHANGE_AREA]: 'Need to change zip code?',
    [TK.CHANGE_POSTAL_CODE]: 'Need to change Postal Code?',
    [TK.CHANGE_AREA_INFO]:
      'Your delivery zip code and state are locked as per your selection. You can modify the delivery zip by selecting "Need to change zip code" option',
    [TK.CHANGE_POSTAL_CODE_INFO]:
      'Your delivery postal code and state are locked as per your selection. You can modify the delivery postal code by selecting "Need to change postal code" option',
    [TK.CART_POSTAL_CODE_INFO]:
      'Each store carries different treats. To change the zip code, you must start a new order. This ensures your treats are still available.',
    [TK.CHANGE_ZIP_TITLE]: 'change zip code',
    [TK.CHANGE_ZIP_DESCRIPTION]:
      'Each store carries different treats. Changing the zip code will restart the process from the product page so we can check that your selection is still available.',
    [TK.CHANGE_BACK_BUTTON]: 'Go Back',
    [TK.CHANGE_ZIP_BUTTON]: 'Change Zip Code',
    [TK.CHANGE_POSTAL_TITLE]: 'change postal code',
    [TK.CHANGE_POSTAL_DESCRIPTION]:
      'Each store carries different treats. Changing the postal code will restart the process from the product page so we can check that your selection is still available.',
    [TK.CHANGE_POSTAL_BUTTON]: 'Change Postal Code',
    [TK.BRAND_VALUE]: '{{brand_value}}',
    [TK.STORES_NEAR_YOU]: '{{amountOfStores}} Stores Near You',
    [TK.STORE_NEAR_YOU]: '{{amountOfStores}} Store Near You',
    [TK.LOAD_MORE_STORES_BUTTON_TEXT]: 'Load More',
    [TK.PRIVACY_POLICY]: 'Privacy Policy',
    [TK.TERMS_OF_USE]: 'Terms of Use',
    [TK.CONCERNED_ABOUT_PRIVACY]:
      'Concerned about privacy? View our policies below.',
    [TK.LOCATION_SERVICES_OFF]:
      'It looks like location services are turned off.',
    [TK.TURN_ON_LOCATION_SERVICES]:
      'To find an Edible store near you, use the search feature or the interactive map above. Or, turn on location services on your device.',
    [TK.STORE_SHOWING_AMOUNT_DISPLAY_TEXT]:
      'Showing {{amountOfStoresCurrentlyDisplayed}} of {{amountOfStoresTotal}}',
    [TK.STORE_SHOWING_LOAD_MORE_TEXT]: 'Load 8 More',
    [TK.APPLY]: 'Apply',
    [TK.CLEAR_ALL_FILTERS]: 'Clear All Filters',
    [TK.CLEAR_ALL_FILTERS_ARIA]: 'Clear all applied filters',
    [TK.REMOVE_FILTER_ARIA]: 'Remove filter for {{filter}}',
    [TK.ERROR_MESSAGE_OPEN_YOUR_OWN_STORE]: 'Open Your Own Store',
    [TK.ERROR_MESSAGE_WE_SHIP_TEXT]:
      'We’re sorry, we couldn’t find any stores nearby. But, we may be able to ship some of our gourmet treats to you or your loved one!',
    [TK.ERROR_MESSAGE_OH_NO]: 'Oh no!',
    [TK.ERROR_MESSAGE_DIFFERENT_SEARCH]:
      'Try a different city, state or zip to view results',
    [TK.ERROR_MESSAGE_DIFFERENT_SEARCH_AND_FILTER]:
      'Try a different city, state or zip, or change your filters to view results.',
    [TK.ERROR_MESSAGE_SEARCH_AND_FILTER_CRITERIA]:
      'We’re sorry, we couldn’t find any stores that match your criteria.',
    [TK.ERROR_MESSAGE_OPEN_STORE_TEXT]:
      'Want to be the first to open an Edible Arrangements store near you? You can own your own franchise location to deliver tasty treats to your neighborhood.',
    [TK.ERROR_MESSAGE_NEW_STORES_TEXT]:
      'New locations open all the time, so check back soon!',
    [TK.DISTANCE_FILTER_OPTION]: 'Within {{distance}} {{distanceMetric}}',
    [TK.DISTANCE_TEXT]: 'Distance',
    [TK.SERVICES_OFFERED_TEXT]: 'Services Offered',
    [TK.FILTERS_TEXT]: 'Filters',
    [TK.FIND_A_STORE]: 'Find a Store',
    [TK.MOBILE_FILTER_TEXT]: 'Filter Results',
    [TK.CUSTOM_GREETING_CARDS]: 'Custom Greeting Cards',
    [TK.SEARCH_BY_OCCASION]: 'Search by occasion',
    [TK.STORE_FINDER_HOME]: 'Home',
    [TK.STORE_FINDER_TITLE]: 'Edible Store Locator',
    [TK.STORE_FINDER_DESCRIPTION]:
      'Visit one of our locations worldwide for a free sample, exclusive offers & in-store specials!',
    [TK.STORE_FINDER_PLACEHOLDER]: 'Search...',
    [TK.STORE_FINDER_PLACEHOLDER_CA]: 'Rechercher...',
    [TK.STORE_FINDER_LOCATION]: 'Location',
    [TK.STORE_FINDER_CHOOSE_FROM_LIST]: 'Choose from the list below',
    [TK.STORE_FINDER_VALIDATION_ERROR]: 'Enter a valid city and state or zip',
    [TK.STORE_FINDER_VALIDATION_ERROR_CA]:
      'Enter a valid City and Province or Postal Code',
    [TK.STORE_FINDER_BUTTON]: 'Find a Store',
    [TK.STORE_FINDER_BUTTON_LOADING_TEXT]: 'Retrieving Store(s)…',
    [TK.INPUT_ADORNMENT]: 'Enter City, State or Zip',
    [TK.INPUT_ADORNMENT_CA]: 'Enter City, Province or Postal Code',
    [TK.STORE_FINDER_FRANCHISE_DESCRIPTION]:
      'Learn about opening your own Edible storefront and join our passionate community of franchise owners across the globe.',
    [TK.LEARN_MORE_STORES]: 'Learn More',
    [TK.LOAD_MORE_STORE_LIST_ARIA_TEXT]: 'Store list pagination',
    [TK.LOAD_MORE_STORES_ARIA_TEXT]: 'Load more store results',
    [TK.OPEN_FRANCHISE_LEARN_MORE_BUTTON]:
      'Open Your Own Franchise Learn More Button',
    [TK.OPEN_FRANCHISE_BANNER]: 'Open Your Own Franchise Banner',
    [TK.INVALID_SEARCH_TEXT]:
      'Enter a valid city and state or zip in the field above to see results',
    [TK.COMING_SOON_STORE_TEXT]: 'New Stores Coming Soon!',
    [TK.CALL_EDIBLE_STORE]: 'Call this Edible Store',
    [TK.CONTACT_US]: 'Contact Us',
    [TK.EMAIL_EDIBLE_STORE]: 'Email this Edible Store',
    [TK.GET_DIRECTIONS]: 'Get Edible Store Directions',
    [TK.STORE_FINDER_PAGE_META_TAG_TITLE]:
      'Edible Arrangements Locations & Stores Near You',
    [TK.STORE_FINDER_PAGE_META_TAG_DESCRIPTION]:
      'Find an Edible Arrangements location near you. Your one stop of gift delivery, pick-up, in-store exclusive offers and more. Explore the stores near you here!',
    [TK.STORE_DETAILS_BREADCRUMB]:
      'Edible Store {{storeNumber}} - {{city}}, {{state}}',
    [TK.STORE_ADDRESS1]: 'Edible® {{storeNumber}}, {{address1}}',
    [TK.STORE_ADDRESS2]: 'Edible® {{storeNumber}}, {{address1}}, {{address2}}',
    [TK.STORE_BANNER_BODY]:
      'Shop gifts and treats for someone else (or yourself!) at Edible Arrangements {{city}}, {{state}} - {{address1}}.',
    [TK.STORE_BANNER_BUTTON]: 'Shop Now',
    [TK.FRANCHISE_BANNER_BUTTON_LABEL]:
      'Open Your Own Franchise Banner Button Text',
    [TK.STORE_BANNER_TITLE]: 'Come see us!',
    [TK.STORE_BANNER_ALT_TEXT]: 'Visit and shop our Edible Store',
    [TK.FRANCHISE_BANNER_ALT_TEXT]:
      'Learn more about Owning an Edible Franchise',
    [TK.FRANCHISE_BANNER_SUB_TITLE_LABEL]:
      'Open Your Own Franchise Banner Subtitle',
    [TK.FRANCHISE_BANNER_TEXT_CONTAINER]:
      'Open Your Own Franchise Banner Text Container',
    [TK.FRANCHISE_BANNER_ARIA_LABEL]: 'Open Your Own Franchise Banner',
    [TK.FRANCHISE_BANNER_ARIA_TITLE_LABEL]:
      'Open Your Own Franchise Banner Title',
    [TK.FRANCHISE_BANNER_ARIA_BODY_LABEL]:
      'Open Your Own Franchise Banner Body',
    [TK.SERVICED_AREAS_TITLE]: 'Service Areas',
    [TK.ABOUT_STORE_TITLE]: 'About Our Store',
    [TK.ABOUT_STORE_ONE]:
      "Edible Arrangements® {{storeNumber}} in {{city}}, {{state}} first opened in {{opening}}. Ever since, we’ve been helping people in our local community celebrate all kinds of occasions – big and small. Our fruit arrangements and gifts are always freshly-crafted using fruit that's grown and picked to our Fruit Expert® standards. And, we have the best variety of gourmet chocolate Dipped Fruit™, too! Visit us any time for a FREE sample!",
    [TK.ABOUT_STORE_TWO]:
      'Did you know we also have fresh fruit treats you can enjoy on the go? Stop by today to grab a fresh fruit salad, Edible® Donut, chocolate Dipped Fruit™ Cone, or any one of our other delicious fresh fruit snacks! They’re perfect for picnics, lunch break snacks, and even as an afternoon pick-me-up!',
    [TK.ABOUT_STORE_THREE]:
      'If you need a birthday gift, wedding favors, a holiday centerpiece, or even a little something just because, give us a call at <phone>{{phoneNumber}}</phone>. We can’t wait to meet you!',
    [TK.SOCIAL_MEDIA_TITLE]: "Let's Connect!",
    [TK.SOCIAL_MEDIA_BODY]:
      'Follow this store on social media for exclusive promotions!',
    [TK.SOCIAL_FACEBOOK_ARIA_LABEL]: 'Follow Edible Store on Facebook',
    [TK.SOCIAL_INSTAGRAM_ARIA_LABEL]: 'Follow Edible Store on Facebook',
    [TK.SOCIAL_PINTEREST_ARIA_LABEL]: 'Follow Edible Store on Pinterest',
    [TK.SOCIAL_TWITTER_ARIA_LABEL]: 'Follow Edible Store on Twitter',
    [TK.SOCIAL_YOUTUBE_ARIA_LABEL]: 'Follow Edible Store on YouTube',
    [TK.CATEGORIES_TITLE]: "We Think You'll Like These Popular Gifts",
    [TK.DISTANCE_AWAY]: '~{{distance}} {{distanceMetric}} Away',
    [TK.DISTANCE_METRIC]: '~{{distance}} {{distanceMetric}}',
    [TK.POPULAR_GIFT]: 'Popular Gift Section',
    [TK.BLOG_CAROUSEL]: 'Blog Carousel Display',
    [TK.STORE_DETAILS_ADDRESS1]:
      'Edible Arrangements {{city}}, {{state}} - {{address1}}',
    [TK.STORE_DETAILS_ADDRESS2]:
      'Edible Arrangements {{city}}, {{state}} - {{address1}} {{address2}}',
    [TK.STORE_DETAILS_META_TITLE]:
      'Edible Arrangements {{city}}, {{state}}: {{address1}} {{address2}}',
    [TK.STORE_DETAILS_META_SCHEMA_DESCRIPTION]:
      "Edible Arrangements® {{storeNumber}} in {{city}}, {{state}}  first opened in  {{openingDate}}. Ever since, we've been helping people in our local community celebrate all kinds of occasions - big and small. Our fruit arrangements and gifts are always freshly-crafted using fruit that's grown and picked to our Fruit Expert® standards. And, we have the best variety of gourmet chocolate Dipped Fruit™, too! (Visit us any time for a FREE sample!)  Did you know we also have fresh fruit treats you can enjoy on the go? Stop by today to grab a fresh fruit smoothie, Froyo Fruit Shake™, Edible® Donut, chocolate Dipped Fruit™ Cone, or any one of our other delicious fresh fruit snacks! They're perfect for picnics, lunch break snacks, and even as an afternoon pick-me-up!If you need a birthday gift, wedding favors, a holiday centerpiece, or even a little something just because, give us a call at {{storePhoneNumber}}. We can't wait to meet you!",
    [TK.STORE_DETAILS_META_DESCRIPTION]:
      'Grab a healthy delicious fruit smoothie, chocolate dipped fruit treat, donut or even fresh fruit salad at the Edible Arrangements store in {{city}} today!',
    [TK.STORE_DETAILS_BREADCRUMB]:
      'Edible Store {{storeNumber}} - {{city}}, {{state}}',
    [TK.STORE_ADDRESS1]: 'Edible® {{storeNumber}}, {{address1}}',
    [TK.STORE_ADDRESS2]: 'Edible® {{storeNumber}}, {{address1}}, {{address2}}',
    [TK.STORE_BANNER_BODY]:
      'Shop gifts and treats for someone else (or yourself!) at Edible Arrangements {{city}}, {{state}} - {{address1}}.',
    [TK.STORE_BANNER_BUTTON]: 'Shop Now',
    [TK.FRANCHISE_BANNER_BUTTON_LABEL]:
      'Open Your Own Franchise Banner Button Text',
    [TK.STORE_BANNER_TITLE]: 'Come see us!',
    [TK.STORE_BANNER_ALT_TEXT]: 'Visit and shop our Edible Store',
    [TK.FRANCHISE_BANNER_ALT_TEXT]:
      'Learn more about Owning an Edible Franchise',
    [TK.FRANCHISE_BANNER_SUB_TITLE_LABEL]:
      'Open Your Own Franchise Banner Subtitle',
    [TK.FRANCHISE_BANNER_TEXT_CONTAINER]:
      'Open Your Own Franchise Banner Text Container',
    [TK.FRANCHISE_BANNER_ARIA_LABEL]: 'Open Your Own Franchise Banner',
    [TK.FRANCHISE_BANNER_ARIA_TITLE_LABEL]:
      'Open Your Own Franchise Banner Title',
    [TK.FRANCHISE_BANNER_ARIA_BODY_LABEL]:
      'Open Your Own Franchise Banner Body',
    [TK.DIRECTIONS]: 'Get Directions',
    [TK.STORE_COMING_SOON_ADDRESS]: 'Edible® {{storeNumber}}, {{address1}}',
    [TK.STORE_BANNER_COMING_SOON_BODY]:
      'Follow Edible Arrangements {{city}}, {{state}} - {{address1}} for early access to exciting offers and exclusive treats.',
    [TK.STORE_BANNER_COMING_SOON_BUTTON]: 'Shop Now',
    [TK.STORE_BANNER_COMING_SOON_TITLE]: 'Opening Soon!',
    [TK.STORE_BANNER_COMING_SOON_ALT_TEXT]: 'Opening Soon Store Banner.',
    [TK.FRANCHISE_BANNER_STORE_COMING_SOON_ALT_TEXT]:
      'Learn more about Owning an Edible Franchise',
    [TK.FRANCHISE_BANNER_STORE_COMING_SOON_BODY]:
      'Learn about opening your own Edible storefront and join our passionate community of franchise owners across the globe.',
    [TK.FRANCHISE_BANNER_STORE_COMING_SOON_BUTTON]: 'Learn More',
    [TK.COMING_SOON_TEXT]: 'This Store is Opening Soon!',
    [TK.STORE_COMING_SOON_ABOUT_STORE_TITLE]: 'About Our Store',
    [TK.STORE_COMING_SOON_ABOUT_STORE_ONE]: `Edible Arrangements® {{storeNum}} in {{city}}, {{state}} will be opening soon to Make Life a Little Sweeter® for our local community!`,
    [TK.STORE_COMING_SOON_ABOUT_STORE_TWO]: `Our fruit arrangements and gifts are always made fresh daily, using fruit that's grown and picked to our Fruit Expert® standards. And, we have the best variety of gourmet chocolate dipped fruit, too! Try our legendary chocolate dipped strawberries, apples, pineapple, bananas, oranges and pears`,
    [TK.STORE_COMING_SOON_ABOUT_STORE_THREE]: `Here, you'll truly find oly the freshest fruit gifts. When we open, stop by and see why ours is considered The Best Dipped Fruit, Period®.`,
    [TK.STORE_COMING_SOON_ABOUT_STORE_FOUR]: `We'll be opening our doors to the public, soon. Once we do, we can't wait to help you choose the perfect fruit bouquet or dipped fruit box for your special occasion! So stop by soon if you need a birthday gift, wedding favors, a holiday centerpiece, or even a little something just because.`,
    [TK.SOCIAL_MEDIA_TITLE]: "Let's Connect!",
    [TK.SOCIAL_MEDIA_BODY]:
      'Follow this store on social media for exclusive promotions!',
    [TK.STORE_COMING_SOON_SOCIAL_FACEBOOK_ARIA_LABEL]:
      'Follow Edible Store on Facebook',
    [TK.STORE_COMING_SOON_SOCIAL_INSTAGRAM_ARIA_LABEL]:
      'Follow Edible Store on Instagram',
    [TK.STORE_COMING_SOON_SOCIAL_PINTEREST_ARIA_LABEL]:
      'Follow Edible Store on Pinterest',
    [TK.STORE_COMING_SOON_SOCIAL_TWITTER_ARIA_LABEL]:
      'Follow Edible Store on Twitter',
    [TK.STORE_COMING_SOON_SOCIAL_YOUTUBE_ARIA_LABEL]:
      'Follow Edible Store on YouTube',
    [TK.STORE_COMING_SOON_CATEGORIES_TITLE]:
      "We Think You'll Like These Popular Gifts",
    [TK.STORE_COMING_SOON_DISTANCE_AWAY]:
      '~{{distance}} {{distanceMetric}} Away',
    [TK.STORE_COMING_SOON_DETAILS_NO_ADDRESS]:
      'Edible Arrangements {{city}}, {{state}}',
    [TK.STORE_COMING_SOON_DETAILS_ADDRESS1]:
      'Edible Arrangements {{city}}, {{state}} - {{address1}}',
    [TK.STORE_COMING_SOON_DETAILS_ADDRESS2]:
      'Edible Arrangements {{city}}, {{state}} - {{address1}} {{address2}}',
    [TK.STORE_COMING_SOON_DETAILS_META_TITLE]:
      'Edible Arrangements {{city}}, {{state}}: {{address1}} {{address2}}',
    [TK.STORE_COMING_SOON_DETAILS_META_SCHEMA_DESCRIPTION]:
      "Edible Arrangements® {{storeNumber}} in {{city}}, {{state}}  first opened in  {{openingDate}}. Ever since, we've been helping people in our local community celebrate all kinds of occasions - big and small. Our fruit arrangements and gifts are always freshly-crafted using fruit that's grown and picked to our Fruit Expert® standards. And, we have the best variety of gourmet chocolate Dipped Fruit™, too! (Visit us any time for a FREE sample!)  Did you know we also have fresh fruit treats you can enjoy on the go? Stop by today to grab a fresh fruit smoothie, Froyo Fruit Shake™, Edible® Donut, chocolate Dipped Fruit™ Cone, or any one of our other delicious fresh fruit snacks! They're perfect for picnics, lunch break snacks, and even as an afternoon pick-me-up!If you need a birthday gift, wedding favors, a holiday centerpiece, or even a little something just because, give us a call at {{storePhoneNumber}}. We can't wait to meet you!",
    [TK.STORE_COMING_SOON_DETAILS_META_DESCRIPTION]:
      'Grab a healthy delicious fruit smoothie, chocolate dipped fruit treat, donut or even fresh fruit salad at the Edible Arrangements store in {{city}} today!',
    [TK.SUBSCRIPTION_TITLE]: 'Be Notified When This Store Opens!',
    [TK.SUBSCRIPTION_SUBTITLE]:
      'Provide your email address for store updates and special promotions.',
    [TK.REDIRECT_SECTION_TITLE]: 'Need to Order Your Treats Today?',
    [TK.REDIRECT_SECTION_SUBTITLE]:
      'Search for an available store in your area and order online for pickup or delivery.',
    [TK.FIND_STORE_BUTTON]: 'Find a Store',
    [TK.SUBSCRIPTION_FOOTER_DIALOG_TITLE]: 'Sweet!',
    [TK.SUBSCRIPTION_FOOTER_DIALOG_SUBTITLE]: 'Thanks for signing up.',
    [TK.SUBSCRIPTION_FOOTER_DIALOG_INFORM_EMAIL]:
      'Check your inbox for your first email from us soon!',
    [TK.SUBSCRIPTION_FOOTER_DIALOG_INFORM_TEXT]:
      'Check your messages for your first text from us soon!',
    [TK.SUBSCRIPTION_FOOTER_DIALOG_SOCIAL_LINKS_TITLE]:
      'Make sure you connect with us here, too:',
    [TK.SUBSCRIPTION_EMAIL_DIALOG_FORM_STEP_BACKGROUND_ALT]:
      'Email subscription form step background',
    [TK.SUBSCRIPTION_EMAIL_DIALOG_SUBMIT_SUCCESS_STEP_BACKGROUND_ALT]:
      'Email subscription submit success step background',
    [TK.SUBSCRIPTION_FACEBOOK]: 'facebook',
    [TK.SUBSCRIPTION_TWITTER]: 'twitter',
    [TK.SUBSCRIPTION_INSTAGRAM]: 'instagram',
    [TK.SUBSCRIPTION_LINKEDIN]: 'linkedin',
    [TK.SUBSCRIPTION_YOUTUBE]: 'youtube',
    [TK.SUBSCRIPTION_EMAIL_FORM_ERROR]: 'Enter a valid email address',
    [TK.SUBSCRIPTION_EMAIL_FORM_PLACEHOLDER]: 'yourname@email.com',
    [TK.POPULAR_GIFTS]: 'Popular Gifts',
    [TK.TODAYS_STORE_HOURS]: `Today's Store Hours`,
    [TK.HOURS]: `Hours`,
    [TK.CYO_BUNDLE_TITLE]: 'create your own gift',
    [TK.CYO_BUNDLE_DESCRIPTION]:
      'Choosing the perfect, personalized gift has never been easier! Curate your personalized combo of fresh or chocolate dipped fruits, cakes, cookies, brownies, flowers, and more. Plus, the more you add, the more you save.',
    [TK.CYO_BUNDLE_STEP_ONE]: 'Add products to create the perfect gift.',
    [TK.CYO_BUNDLE_STEP_TWO]: 'Tell us where your treat is going.',
    [TK.CYO_BUNDLE_STEP_THREE]: 'Choose when you want it, pickup or delivery.',
    [TK.CYO_BUNDLE_START_CREATING]: 'Start Creating',
    [TK.CYO_BUNDLE_MINI_CART_TITLE]: 'build your gift:',
    [TK.CYO_BUNDLE_MINI_CART_ADD_SAVE]: 'Add more, save more!',
    [TK.CYO_BUNDLE_MINI_CART_SUBTOTAL]: 'Product Subtotal',
    [TK.CYO_BUNDLE_MINI_CART_TAX_FEE]:
      'Total including delivery and taxes calculated at checkout',
    [TK.CYO_BUNDLE_PAS_TITLE]: 'nice choice!',
    [TK.CYO_BUNDLE_ITEM]: 'Item',
    [TK.CYO_BUNDLE_ITEMS]: 'Items',
    [TK.CYO_BUNDLE_ADD_PRODUCT]:
      'Please select at least two products to proceed',
    [TK.CYO_BUNDLE_PAS_SUB_TITLE]: 'Let`s wrap that up for you.',
    [TK.LIMITED_LINES_HELPER_TEXT]:
      'We have limited space for printing, so we have to limit the number of lines available as well. Lines here do not represent the real amount of lines, pay attention to the indicators.',
    [TK.FIELD_REQUIRED_HELPER_TEXT]: 'This is required field',
    [TK.LINES_LIMIT_EXCEEDED]: 'Line limit reached',
    [TK.TYPING_LAST_LINE]: 'You are in the last line',
    [TK.REACHING_LAST_LINE]: 'Reaching limit',
    [TK.SPL_CHARS_ERROR]: 'Characters (<>) are not allowed',
    [TK.EMOJIS_ENTERED]: 'Emojis are not allowed',
    [TK.REDUCE_MESSAGE_LENGTH_HELPER_TEXT]: 'Reduce the length of your message',
    [TK.ORDER_CONFIRMATION_PAGE_THANK_YOU_MSG]: 'Thank You for Your Order!',
    [TK.ORDER_CONFIRMATION_PAGE_ORDER_DETAILS_TITLE]: 'order details',
    [TK.ORDER_CONFIRMATION_PAGE_CONFIRM_MAIL]:
      'You should receive a confirmation email at',
    [TK.ORDER_CONFIRMATION_PAGE_CONFIRM_MSG]: `shortly. If you don’t receive an email, re-send it using the button below.`,
    [TK.ORDER_CONFIRMATION_PAGE_CONFIRM_HELP_MSG_PREFIX]:
      'For questions regarding your order, contact',
    [TK.ORDER_CONFIRMATION_PAGE_CONFIRM_HELP_MSG_SUFFIX]:
      'and the Goody customer support team will be happy to help!',
    [TK.ORDER_CONFIRMATION_PAGE_PRINT_CONFIRMATION]: 'Print Confirmation',
    [TK.ORDER_CONFIRMATION_PAGE_PRINT_ORDER_DETAILS]: 'Print Order Details',
    [TK.ORDER_CONFIRMATION_PAGE_RESEND_CONFIRMATION]: 'Re-send Confirmation',
    [TK.ORDER_CONFIRMATION_PAGE_RECIPIENT_IMG]: 'Recipient Image',
    [TK.ORDER_CONFIRMATION_PAGE_ORDER_TXT]: 'In This Order',
    [TK.ORDER_CONFIRMATION_PAGE_CREDIT_CARD_IMAGE]: 'Credit Card Image',
    [TK.ORDER_CONFIRMATION_PAGE_CREATE_ACCOUNT]: 'Create Account',
    [TK.ORDER_CONFIRMATION_PAGE_VIEW_REWARDS]: 'View Your Rewards',
    [TK.ORDER_CONFIRMATION_PAGE_TRACK_ORDER]: 'Track Order',
    [TK.ORDER_CONFIRMATION_PAGE_TRACK_ORDER_IMG]: 'Track Order Image',
    [TK.ORDER_CONFIRMATION_PAGE_HELP_GREY_ICON]: 'Help_Grey_Icon',
    [TK.ORDER_CONFIRMATION_PAGE_DISCLAIMER_TEXT_LINE1]:
      'Unless specified, product containers may vary.',
    [TK.ORDER_CONFIRMATION_PAGE_DISCLAIMER_TEXT_LINE2]:
      'For flower arrangements, floral type and colors may vary.',
    [TK.ORDER_CONFIRMATION_PAGE_BILLING_INFO_TITLE]: 'Billing Info',
    [TK.ORDER_CONFIRMATION_PAGE_PICKUP_INFO_TITLE]: 'Pickup Information',
    [TK.ORDER_CONFIRMATION_PAGE_PICKUP_IN_STORE]: 'Pickup In-Store',
    [TK.ORDER_CONFIRMATION_PAGE_CURB_PICKUP]: 'Curbside Pickup',
    [TK.ORDER_CONFIRMATION_PAGE_PICKUP_INFO_METHOD]: 'Pickup Method',
    [TK.ORDER_CONFIRMATION_PAGE_PICKUP_INFO_DATE]: 'Pickup Date & Time',
    [TK.ORDER_CONFIRMATION_PAGE_PICKUP_INFO_INSTRUCTION]: 'Pickup Instructions',
    [TK.ORDER_CONFIRMATION_PAGE_PICKUP_INFO_NAME]: 'Name On Order',
    [TK.ORDER_CONFIRMATION_PAGE_PICKUP_INFO_FROM]: 'Pickup From',
    [TK.ORDER_CONFIRMATION_PAGE_DELIVERY_TITLE]: 'Delivery Information',
    [TK.ORDER_CONFIRMATION_PAGE_SHIPMENT_TITLE]: 'Shipment Information',
    [TK.ORDER_CONFIRMATION_PAGE_DELIVERY_POLICY]: 'View our Delivery Policies',
    [TK.ORDER_CONFIRMATION_PAGE_SHIPMENT_POLICY]: 'View our Shipping Policies',
    [TK.ORDER_CONFIRMATION_PAGE_DELIVERY_METHOD_NAME]: 'Delivery Method',
    [TK.ORDER_CONFIRMATION_PAGE_DELIVERY_METHOD]: 'Hand Delivery',
    [TK.ORDER_CONFIRMATION_PAGE_ONE_HOUR_DELIVERY_METHOD]: 'One-Hour Delivery',
    [TK.ORDER_CONFIRMATION_PAGE_SHIPMENT_METHOD]: 'FedEx',
    [TK.ORDER_CONFIRMATION_PAGE_MORE_INFO]: 'For more info',
    [TK.ORDER_CONFIRMATION_PAGE_MORE_INFORMATION]: 'For more information',
    [TK.ORDER_CONFIRMATION_PAGE_SHIPMENT_INFO]: 'contact Customer Service at',
    [TK.ORDER_CONFIRMATION_PAGE_CUSTOMER_CARE]: '678-992-2390',
    [TK.ORDER_CONFIRMATION_PAGE_DELIVERY_INFO_ON]: 'Delivering On',
    [TK.ORDER_CONFIRMATION_PAGE_DELIVERY_INFO_INSTRUCTION]:
      'Delivery Instructions',
    [TK.ORDER_CONFIRMATION_PAGE_DELIVERY_INFO_TO]: 'Delivering To',
    [TK.ORDER_CONFIRMATION_PAGE_DELIVERY_INFO_FROM]: 'Delivering From',
    [TK.ORDER_CONFIRMATION_PAGE_AMAZON_PAY_IMAGE]: 'Amazon Pay Image',
    [TK.ORDER_CONFIRMATION_PAGE_APPLE_PAY_IMAGE]: 'Apple Pay Image',
    [TK.ORDER_CONFIRMATION_PAGE_GOOGLE_PAY_IMAGE]: 'Google Pay Image',
    [TK.ORDER_CONFIRMATION_PAGE_LINK_IMAGE]: 'LINK Image',
    [TK.ORDER_CONFIRMATION_PAGE_PAID_BY]: 'Paid By Apple pay',
    [TK.ORDER_CONFIRMATION_PAGE_PAID_BY_GPAY]: 'Paid By Google pay',
    [TK.ORDER_CONFIRMATION_PAGE_PAID_BY_LINK]: 'Paid By Link',
    [TK.ORDER_CONFIRMATION_PAGE_TRANSACTION_ID]: 'Transaction ID: ',
    [TK.ORDER_CONFIRMATION_PAGE_NEED_MORE_SHOPPING]:
      'need to do more shopping?',
    [TK.ORDER_CONFIRMATION_PAGE_PAYMENT_ID]: 'PAYMENT ID: ',
    [TK.ORDER_CONFIRMATION_PAGE_VENMO_IMAGE]: 'Venmo Image',
    [TK.ORDER_CONFIRMATION_PAGE_PAYPAL_IMAGE]: 'Paypal Image',
    [TK.ORDER_CONFIRMATION_PAGE_PRODUCT_IMAGE]: 'product image',
    [TK.ORDER_CONFIRMATION_PAGE_STRAWBERRY]: 'STRAWBERRY',
    [TK.ORDER_CONFIRMATION_PAGE_CHECK_ICON]: 'check icon',
    [TK.ORDER_CONFIRMATION_PAGE_NO_INSTRUCTIONS]: 'NO INSTRUCTIONS',
    [TK.ORDER_CONFIRMATION_PAGE_TERMS_TEXT]: 'Terms and Conditions',
    [TK.ORDER_CONFIRMATION_PAGE_LIST_TEXT1]:
      'With your account, you have access to exclusive rewards.',
    [TK.ORDER_CONFIRMATION_PAGE_LIST_TEXT2]: 'See what you’ll earn next!',
    [TK.ORDER_CONFIRMATION_PAGE_ACC_TXT]: 'why not create an account?',
    [TK.ORDER_CONFIRMATION_PAGE_THANKS_MSG]:
      'Thank You for Being a Rewards Member!',
    [TK.ORDER_CONFIRMATION_PAGE_ENJOY_MSG]: 'You’ll Enjoy',
    [TK.ORDER_CONFIRMATION_PAGE_TERMS_MSG]: 'See Terms of Use',

    [TK.ORDER_CONFIRMATION_PAGE_GIFT_MSG]: 'Complimentary Gift Message',
    [TK.ORDER_CONFIRMATION_PAGE_GIFT_TXT]: 'Gift Message:',
    [TK.ORDER_CONFIRMATION_PAGE_GREETING_TXT]: 'Premium Greeting Card',
    [TK.ORDER_CONFIRMATION_PAGE_EMAIL_TXT]:
      'Your email confirmation was re-sent and should arrive in your inbox shortly. If you can’t find it, please check your spam folder.',
    [TK.ORDER_CONFIRMATION_PAGE_ACC_LIST_TEXT1]: '$5 off your first order',
    [TK.ORDER_CONFIRMATION_PAGE_ACC_LIST_TEXT2]: 'Birthday Gift',
    [TK.ORDER_CONFIRMATION_PAGE_ACC_LIST_TEXT3]: 'FREE delivery days',
    [TK.ORDER_CONFIRMATION_PAGE_ACC_LIST_TEXT4]: 'Fast checkout',
    [TK.ORDER_CONFIRMATION_PAGE_ACC_LIST_TEXT5]: 'Priority customer support',
    [TK.ORDER_CONFIRMATION_PAGE_ACC_LIST_TEXT6]: 'Exclusive perks',
    [TK.ORDER_CONFIRMATION_PAGE_SPL_TXT]: 'You Made it Special With',
    [TK.ORDER_CONFIRMATION_PAGE_GREETING_MSG]:
      'Your premium greeting card includes your chosen card front and personal gift message. It will be printed by the selected Edible store and placed in an envelope alongside your order.',
    [TK.ORDER_CONFIRMATION_PAGE_NEW_ORDER]: 'Start New Order',
    [TK.ORDER_CONFIRMATION_PAGE_KEEP_SHOPPING_TITLE]: 'Want to Keep Shopping?',
    [TK.ORDER_CONFIRMATION_PAGE_UPGRADE_TEXT]: 'You Selected These Upgrades',
    [TK.ORDER_CONFIRMATION_PAGE_CYOA_TITLE1]: 'Box with',
    [TK.ORDER_CONFIRMATION_PAGE_CYOA_TITLE2]: 'fruit/topping combinations',
    [TK.ORDER_CONFIRMATION_PAGE_CYODB_TITLE]:
      'Board with baked goods and dipped fruit/berries',
    [TK.ORDER_CONFIRMATION_PAGE_CYODB_NAME]: 'Create Your Own Desserts Board',
    [TK.ORDER_CONFIRMATION_PAGE_CYO_6COOKIEBOX_TITLE]:
      'Box with up to 3 cookie combinations',
    [TK.ORDER_CONFIRMATION_PAGE_CYO_12COOKIEBOX_TITLE]:
      'Box with up to 6 cookie combinations',
    [TK.ORDER_CONFIRMATION_PAGE_CYO_6CUPCAKEBOX_TITLE]:
      'Box with up to 3 cupcake combinations',
    [TK.ORDER_CONFIRMATION_PAGE_CYO_12CUPCAKEBOX_TITLE]:
      'Box with up to 6 cupcake combinations',
    [TK.ORDER_CONFIRMATION_PAGE_CYO_6COOKIEBOX_NAME]:
      'Create Your Own Cookie Box - 6 Cookies',
    [TK.ORDER_CONFIRMATION_PAGE_CYO_12COOKIEBOX_NAME]:
      'Create Your Own Cookie Box - 12 Cookies',
    [TK.ORDER_CONFIRMATION_PAGE_CYO_6CUPCAKEBOX_NAME]: '6 Cupcakes',
    [TK.ORDER_CONFIRMATION_PAGE_CYO_12CUPCAKEBOX_NAME]: '12 Cupcakes',
    [TK.ORDER_CONFIRMATION_PAGE_CYO_DESSERT_NAME]:
      'Create Your Own Desserts Box - One Size',
    [TK.ORDER_CONFIRMATION_PAGE_CYO_DIPPEDFRUIT_NAME]:
      'Create Your Own Dipped Fruit Box',
    [TK.ORDER_CONFIRMATION_PAGE_PACKAGE_TITLE1]: 'Bundle containing',
    [TK.ORDER_CONFIRMATION_PAGE_PACKAGE_TITLE2]: 'special treats',
    [TK.ORDER_CONFIRMATION_PAGE_ORDER_HISTORY]: 'Order History',
    [TK.ORDER_CONFIRMATION_PAGE_SALE_TITLE]: 'Total Charged:',
    [TK.ORDER_CONFIRMATION_PAGE_ORDER_NUMBER]: 'Order Number:',
    [TK.ORDER_CONFIRMATION_PAGE_SALE_ITEM_COUNT]: '{{Number}} Item',
    [TK.ORDER_CONFIRMATION_PAGE_SALE_QUANTITY]: '{{#}} x',
    [TK.ORDER_CONFIRMATION_PAGE_SALE_ADDON_QUANTITY]: 'x{{#}}',
    // eslint-disable-next-line no-template-curly-in-string
    [TK.ORDER_CONFIRMATION_PAGE_SALE_PRICE]: '${{Price}}',
    [TK.ORDER_CONFIRMATION_PAGE_SALE_SUMMARY]: 'Order Summary',
    [TK.ORDER_CONFIRMATION_PAGE_SALE_DELIVERY_FEE]: 'Delivery Fees',
    [TK.ORDER_CONFIRMATION_PAGE_SALE_SHIPMENT_CHARGE]: 'Shipment Charge',
    [TK.ORDER_CONFIRMATION_PAGE_SALE_SERVICE_FEE]: 'Service Fee:',
    [TK.ORDER_CONFIRMATION_PAGE_SALE_SUBTOTAL]: 'Subtotal',
    [TK.ORDER_CONFIRMATION_PAGE_SALE_TOTAL]: 'Order Total',
    [TK.ORDER_CONFIRMATION_PAGE_COUPON_CODE]: 'Coupon Code ({{CouponCode}})',
    [TK.ORDER_CONFIRMATION_PAGE_RECIPIENT]: 'Recipient {{RecipientNumber}}',
    [TK.ORDER_CONFIRMATION_CONTINUE_SHOPPING]: 'Continue Shopping',
    [TK.ORDER_CONFIRMATION_RECIPIENT_TEXT]: 'Recipient',
    [TK.ORDER_CONFIRMATION_RECIPIENTS_TEXT]: 'Recipients',
    [TK.ORDER_CONFIRMATION_PAGE_PAYMENT_INFO]: 'Payment Information',
    [TK.ORDER_CONFIRMATION_PAGE_PAYMENT_METHOD]: 'Payment Method',
    [TK.ORDER_CONFIRMATION_PAGE_PAYMENT_CREDIT]: 'Credit Card',
    [TK.ORDER_CONFIRMATION_TIPPING_LEAVE_TIP]: 'Leave a tip',
    [TK.ORDER_CONFIRMATION_TIPPING_DESCRIPTION]:
      'Say “thank you” with a tip to the people that make your experience extra-special. 100% goes to the store team that prepares your order and is automatically added to your total.',

    [TK.ORDER_CONFIRMATION_TIPPING_INPUT_LABEL]: 'Add a custom tip',
    [TK.ORDER_CONFIRMATION_TIPPING_INPUT_LABEL_DEPLOYED]: 'Custom Tip',
    [TK.ORDER_CONFIRMATION_TIPPING_TOOLTIP]:
      'A recommended tip has been selected by default. Providing a tip is optional and 100% goes to the store that preps your order.',
    [TK.ORDER_CONFIRMATION_TIPPING_EXCEEDS_ORDER_TOTAL]:
      'Tip amount cannot exceed the order total.',
    [TK.ORDER_CONFIRMATION_TIPPING_NONE]: 'None',
    [TK.ORDER_CONFIRMATION_TIPPING_SUMMARY]: 'Tip',
    [TK.ORDER_CONFIRMATION_TIPPING_SUMMARY_TOOLTIP]:
      'Your tip is entirely optional, and every dollar goes directly to the store that preps your order.',
    [TK.ORDER_CONFIRMATION_TIPPING_DELIVERY_SUMMARY_TOOLTIP]:
      'Your tip is entirely optional, and every dollar goes directly to the store that preps your order.',
    [TK.CART_ITEM_COUNT_MULTI]: 'Cart: {{productCount}} Items',
    [TK.CART_ITEM_COUNT_SINGLE]: 'Cart: {{productCount}} Item',
    [TK.RECIPIENT_COUNT_MULTI]: '{{recipientCount}} Recipients',
    [TK.RECIPIENT_COUNT_SINGLE]: '{{recipientCount}} Recipient',
    [TK.CONTINUE_SHOPPING]: 'Continue Shopping',
    [TK.RETURN_TO_CART]: 'Return to Cart',
    [TK.CHECKOUT_NOW]: 'Checkout Now',
    [TK.RECIPIENT]: 'Recipient {{recipientNumber}}',
    [TK.RECIPIENT_VIEW_EDIT_BUTTON]: 'View/Edit',
    [TK.RECIPIENT_VIEW_EDIT_HIDE_BUTTON]: 'Hide',
    [TK.FREE_DELIVERY_COMPLETED]: 'Congrats! You’ve unlocked FREE Delivery!',
    [TK.FREE_DELIVERY_REMAINING]:
      // eslint-disable-next-line no-template-curly-in-string
      '${{amount}} away from FREE Next-Day & Beyond Delivery!',
    [TK.FREE_DELIVERY_COMPLETED_MOBILE]:
      'Congrats! You’ve unlocked FREE Delivery!',
    [TK.CART_TITLE]: 'order summary',
    [TK.TOTAL]: 'Order Total:',
    [TK.CART_TOTAL]: 'Cart Total:',
    [TK.SUBTOTAL]: 'Subtotal:',
    [TK.DELIVERY_FEE]: 'Delivery Fees:',
    [TK.DISTANCE_FEE]: 'Distance Surcharge:',
    [TK.SHIPMENT_CHARGE]: 'Shipment Charge:',
    [TK.DISCOUNT_TOTAL]: 'Discount Total:',
    [TK.STATE_TAX]: 'State Sales Tax',
    [TK.LOCAL_TAX]: 'Local Sales Tax',
    [TK.PROMO]: 'Promo Code:',
    [TK.DELIVERY_POLICY]: 'View our Delivery Policies',
    [TK.SHIPMENT_POLICY]: 'View our Shipping Policies',
    [TK.EDIT_DELIVERY_INFO]: 'Edit Delivery Info',
    [TK.EDIT_DELIVERY_TITLE]: 'Delivering To',
    [TK.RECIPIENT_TOTAL]: 'Recipient {{number}} Order Total:',
    [TK.MADE_IT_SPECIAL]: 'You Made it Special With:',
    [TK.MAKE_IT_EXTRA_SPECIAL]: 'Make This Gift Extra Special',
    [TK.SHOP_POPULAR_ADD_ONS]: 'Shop Popular Add-ons',
    [TK.REMOVE_BUTTON_TITLE]: 'Remove',
    [TK.EDIT_BUTTON_TITLE]: 'Edit',
    [TK.GIFT_TXT]: 'Gift Message:',
    [TK.GREETING_TXT]: 'Premium Greeting Card',
    [TK.SAVE_EDIT_TEXT]: 'SAVE',
    [TK.CANCEL_EDIT_TEXT]: 'CANCEL',
    [TK.GIFT_MESSAGE_LABEL]: 'Gift Message',
    [TK.HELP_GREY_ICON]: 'Help_Grey_Icon',
    [TK.GREETING_MSG]:
      'Your premium greeting card includes your chosen card front and personal gift message. It will be printed by the selected Edible store and placed in an envelope alongside your order.',
    [TK.UPGRADE_TEXT]: 'You selected these upgrades',
    [TK.WRAPPER_TEXT]: 'Your selected gift wrap',
    [TK.CYOA_TITLE1]: 'Box with',
    [TK.CYOA_TITLE2]: 'fruit/topping combinations',
    [TK.CYODB_TITLE]: 'Board with baked goods and dipped fruit/berries',
    [TK.CYODB_NAME]: 'Create Your Own Desserts Board',
    [TK.CYO_DESSERT_NAME]: 'Create Your Own Desserts Box - One Size',
    [TK.CYO_DIPPEDFRUIT_NAME]: 'Create Your Own Dipped Fruit Box',
    [TK.CYO_6COOKIEBOX_TITLE]: 'Box with up to 3 cookie combinations',
    [TK.CYO_12COOKIEBOX_TITLE]: 'Box with up to 6 cookie combinations',
    [TK.CYO_6COOKIEBOX_NAME]: 'Create Your Own Cookie Box - 6 Cookies',
    [TK.CYO_12COOKIEBOX_NAME]: 'Create Your Own Cookie Box - 12 Cookies',
    [TK.PROMO_TEXT]: 'Add Promo Code',
    [TK.PROMO_CODE_TEXT]: 'Promo Code:',
    [TK.PROMO_EXPIRES]: 'Expires: ',
    [TK.PROMO_MESSAGE]: ' - {{message}}',
    [TK.MY_EDIBLE_REWARDS_TITLE]: 'My Edible Rewards®',
    [TK.PACKAGE_TITLE1]: 'Bundle containing',
    [TK.PACKAGE_TITLE2]: 'special treats',
    [TK.ADDON_IMAGE]: 'addon image',
    [TK.UPGRADE_IMAGE]: 'upgrade image',
    [TK.COMBINATION_IMAGE]: 'combination image',
    [TK.PROMO_TOOLTIP]: 'You can use only one Reward or Promo code per order.',
    [TK.DELIVERY_TOOLTIP]:
      'These fees help cover the cost of delivery for store owners.',
    [TK.DISTANCE_FEE_TOOLTIP]:
      'Additional surcharges may incur for delivery that exceeds 15 miles. See Terms of Use for more details',
    [TK.CURB_PICKUP]: 'Curbside Pickup',
    [TK.NO_INSTRUCTIONS]: 'NO INSTRUCTIONS',
    [TK.ONE_HOUR_DELIVERY]: 'One-Hour Delivery',
    [TK.DELIVERY_TITLE]: 'delivery information',
    [TK.DELIVERY_METHOD]: 'Delivery Method',
    [TK.DELIVERY_DAY]: 'Delivering On',
    [TK.INDICATES_REQUIRED_FIELD]: '* indicates a required field',
    [TK.CART_DELIVERY_INSTRUCTIONS]: 'Delivery Instructions',
    [TK.CART_DELIVERY_INSTRUCTIONS_PLACEHOLDER]:
      'Provide delivery instructions like crossroads, landmarks, door codes, and where to deliver your order.',
    [TK.DELIVERING_TO]: 'Delivering To',
    [TK.DELIVERY_TO]: 'Delivery To',
    [TK.DELIVERY_ON]: 'Delivery on',
    [TK.CART_DELIVERY_FROM]: 'Delivering From',
    [TK.HAND_DELIVERY]: 'Hand Delivery',
    [TK.PICKUP_TITLE]: 'Pickup Information',
    [TK.PICKUP_METHOD]: 'Pickup Method',
    [TK.PICKUP_DATE_LABEL]: 'Pickup Date',
    [TK.PICKUP_DAY]: 'Pickup Date & Time',
    [TK.CART_PICKUP_INSTRUCTIONS]: 'Pickup Instructions',
    [TK.CART_PICKUP_INSTRUCTIONS_LABEL]: 'Pickup Instructions (optional)',
    [TK.CART_PICKUP_INSTRUCTIONS_PLACEHOLDER]:
      'Provide pickup instructions like wrapping requests, whether you may be late or early, or if someone else might pickup your order on your behalf.',
    [TK.CART_PICKUP_TO]: 'Name On Order',
    [TK.CART_PICKUP_FROM]: 'Pickup From',
    [TK.IN_STORE_PICKUP]: 'In-Store Pickup',
    [TK.VEHICLE_MODEL]: 'Vehicle Model',
    [TK.VEHICLE_COLOR]: 'Vehicle Color',
    [TK.EDIT_PICKUP_INFO]: 'Edit Pickup Info',
    [TK.PICKUP_TIME_PASSED_TITLE]: 'Oh no! This pickup time has passed.',
    [TK.PICKUP_TIME_PASSED_DESCRIPTION]:
      'To continue, please change your pickup time using the field above.',
    [TK.PICKUP_DATE_PASSED_TITLE]: 'Oh no! This pickup date has passed.',
    [TK.PICKUP_DATE_PASSED_DESCRIPTION]:
      'To continue, please change your pickup date by clicking the link provided.',
    [TK.PICKUP_CHANGE_DATE]: 'Change Pickup Date',
    [TK.PICKUP_CHANGE_TIME]: 'Change your pickup time',
    [TK.PICKUP_TO_CONTINUE]: 'To continue, click',
    [TK.PICKUP_BELOW_CHANGE_TIME]: 'below to change your pickup time.',
    [TK.CURB_SIDE_INFO]: 'curbside pickup information',
    [TK.IN_STORE_PICK_UP_INFO]: 'in-store pickup information',
    [TK.SHIPPING_INFORMATION]: 'shipping information',
    [TK.SHIPMENT_TITLE]: 'Shipment Information',
    [TK.SHIPMENT_METHOD]: 'Delivery Method',
    [TK.SHIPMENT_DAY]: 'Delivering On',
    [TK.SHIPMENT_TO]: 'Delivering To',
    [TK.SHIPPER]: 'FedEx',
    [TK.EDIT_SHIPPING_INFO]: 'Edit Shipping Info',
    [TK.SHIPMENT_METHOD_NAME]: 'For more info, contact Customer Service ',
    [TK.SHIPMENT_METHOD_NAME_2]: 'at: 678-992-2390',
    [TK.DISCLAIMER_1]: 'Unless specified, product containers may vary.',
    [TK.DISCLAIMER_2]:
      'For flower arrangements, floral type and colors may vary.',
    [TK.HELP_ICON]: 'Product disclaimer for flowers',
    [TK.CART_SALE_TITLE]: 'Total Charged:',
    [TK.CART_SALE_ITEM_COUNT]: '{{Number}} Item',
    [TK.CART_SALE_QTY]: '{{#}}x',
    [TK.CART_SALE_ADDON_QTY]: 'x{{#}}',
    // eslint-disable-next-line no-template-curly-in-string
    [TK.CART_SALE_PRICE]: '${{Price}}',
    [TK.CART_SALE_SUMMARY]: 'Order Summary',
    [TK.CART_SALE_DELIVERY_FEE]: 'Delivery Fees',
    [TK.CART_SALE_SHIPMENT_CHARGE]: 'Shipment Charge',
    [TK.CART_SALE_SERVICE_FEE]: 'Service Fee:',
    [TK.CART_SALE_SUBTOTAL]: 'Subtotal',
    [TK.CART_SALE_TOTAL]: 'Order Total',
    [TK.CART_COMPLIMENTARY_MESSAGE_TITLE]: 'Complimentary Gift Message',
    [TK.CART_COMPLIMENTARY_GIFT_MESSAGE]: 'Gift Message:',
    [TK.COMPLIMENTARY_NO_CARD_MESSAGE]: 'NO CARD MESSAGE',
    [TK.ONE_HOUR_DELIVERY_WARNING_TITLE]: '1-hour delivery unavailable',
    [TK.ONE_HOUR_DELIVERY_WARNING_TEXT]:
      '1-hour delivery is currently not available for this order. To assist, we have updated your order to Same-day Delivery.',
    [TK.ADD_GIFT_MESSAGE]: 'Add Gift Message',
    [TK.ADD_GIFT_MESSAGE_WARING_TEXT1]: 'Remember to include your name!',
    [TK.ADD_GIFT_MESSAGE_WARING_TEXT2]:
      'Your message is the only way the recipient will know who sent their gift.',
    [TK.CART_FREE]: 'FREE',
    [TK.EDIT]: 'Edit',
    [TK.REMOVE]: 'Remove',
    [TK.START_SHOPPING]: 'Start Shopping',
    [TK.EMPTY_TITLE]: 'Oh No!',
    [TK.EMPTY_SUBTITLE]: 'It Looks Like Your Cart Is Currently Empty.',
    [TK.EMPTY_DESCRIPTION]:
      'Click the button below to browse our products and select the perfect treat for you or your loved one. Then come back here when you’re ready to place your order!',
    [TK.CART_ACCOUNT_TITLE]: 'log in or create an account',
    [TK.CART_ACCOUNT_BODY]: 'With your account, you can',
    [TK.CART_ACCOUNT_EARN_TXT]: ' earn rewards ',
    [TK.CART_ACCOUNT_ORDER_TXT]: 'on this order.',
    [TK.CART_ACCOUNT_ACCOUNT_TXT]: 'With your account, you’ll have access to',
    [TK.CART_ACCOUNT_REWARDS_TXT]: ' exclusive rewards. ',
    [TK.CART_ACCOUNT_LOGIN]: 'Log In',
    [TK.CART_ACCOUNT_CREATE_ACCOUNT]: 'Create Account',
    [TK.CART_ACCOUNT_WELCOME_BACK]: 'Welcome Back!',
    [TK.CART_ACCOUNT_APPLY_REWARDS]:
      'By logging in, you can now apply one of your Edible Rewards® to this order.',
    [TK.CART_ACCOUNT_REWARD_TOOLTIP]:
      'You can use only one Reward or Promo code per order. ',
    [TK.CART_ACCOUNT_ALLERGY_TEXT]: 'Allergy & Safety Information',
    [TK.CART_ACCOUNT_FAQ_TEXT]: 'FAQs',
    [TK.CART_ACCOUNT_NO_REWARDS]: 'You currently have no rewards available.',
    [TK.CART_ACCOUNT_NO_REWARDS_MESSAGE]:
      'With your account, every order you place gets you closer to your next reward! Checkout now to earn more.',
    [TK.CART_ACCOUNT_CONTACTUS_TXT]:
      'Manage your orders, earn rewards, and get exclusive offers with your account.',
    [TK.ORDER_CONFIRMATION_PAGE_PAYMENT_EXPIRY_DATE]: 'Expiry Date:',
    [TK.VDAY_SLIDER_CONTAINER_TITLE]: 'edible official',
    [TK.VDAY_SLIDER_CONTAINER_TITLE1]: 'make things',
    [TK.VDAY_SLIDER_CONTAINER_TITLE2]: 'this valentine’s day',
    [TK.VDAY_SLIDER_CONTAINER_SUBTITLE]:
      'Select your relationship status to find the perfect gift for the love you’re celebrating!',
    [TK.VDAY_SLIDER_TITLE]: 'What’s Your Relationship Status?',
    [TK.VDAY_SLIDER_SHOP_BESTIE]: 'Shop For Your bestie',
    [TK.VDAY_SLIDER_SHOP_SITUATIONSHIP]: 'Shop For Your Situationship',
    [TK.VDAY_SLIDER_SHOP_ESSENTIALS]: 'Shop Valentine’s Essentials',
    [TK.VDAY_SLIDER_SHOP_FLIRT]: 'Shop For Your Forever Flirt',
    [TK.VDAY_SLIDER_SHOP_LOVE]: 'Shop For Your Love',
    [TK.VDAY_SLIDER_URL_BESTIE]: '/besties',
    [TK.VDAY_SLIDER_URL_SITUATIONSHIP]: '/situationship',
    [TK.VDAY_SLIDER_URL_ESSENTIALS]: '/on-thin-ice',
    [TK.VDAY_SLIDER_URL_FLIRT]: '/flirting-with-forever',
    [TK.VDAY_SLIDER_URL_LOVE]: '/love-of-my-life',
    [TK.VDAY_SLIDER_BESTIE]: 'Besties',
    [TK.VDAY_SLIDER_SITUATIONSHIP]: 'Situationship',
    [TK.VDAY_SLIDER_ESSENTIALS]: 'On thin ice',
    [TK.VDAY_SLIDER_FLIRT]: 'Flirting with forever',
    [TK.VDAY_SLIDER_LOVE]: 'Love of my life',
    [TK.ORDER_CONFIRMATION_NO_MESSAGE_TEXT]: 'NO CARD MESSAGE',
    [TK.CYO_BUNDLE_LIST_TITLE]: 'browse the collection',
    [TK.CYO_VIEW_PRODUCT_DETAILS]: 'View Product Details',
    [TK.CYO_BUNDLE_COUPON_BAR_TITLE]: 'create more, save more!',

    [TK.CYO_BUNDLE_COUPON_PROGRESS_TEXT]:
      // eslint-disable-next-line no-template-curly-in-string
      'Only ${{amount}} more to unlock {{discount}} off your order!',
    [TK.CYO_BUNDLE_MAX_COUPON_REACHED]:
      // eslint-disable-next-line no-template-curly-in-string
      'you’ve got {{freeDelivery}} {{discount}} off!',
    [TK.CYO_BUNDLE_FREE_DELIVERY]: 'Free next-day delivery',
    [TK.SUGGESTED_PRODUCTS_TITLE]: 'Cart',
    [TK.SUGGESTED_PRODUCTS_CONTINUE_SHOPPING]: 'Continue Shopping',
    [TK.SUGGESTED_PRODUCTS_START_SHOPPING]: 'Start Shopping',
    [TK.VIEW_ALL]: 'View All',
    [TK.SHOP_NOW]: 'Shop Now',
    [TK.SUGGESTED_PRODUCTS]: 'Are You Forgetting Anything?',
    [TK.SUGGESTED_PRODUCTS_EMPTY]: 'We Think You’ll Like These Popular Gifts',
    [TK.SUGGESTED_PRODUCTS_REWARDS]: 'Check out our trending treats!',
    [TK.VIEW_ALL_PRODUCTS]: 'View All Products',
    [TK.NEED_HELP]: 'Need Help?',
    [TK.CHANGE_SELECTION]: 'Change Selection',
    [TK.PRICE_EA]: 'ea',
    [TK.SAVEBTN]: 'Save Changes',
    [TK.ORDER_CONTACTS_ADD_BUTTON]: 'Home And/Or Work Phone',
    [TK.HIDE_PASSWORD]: 'Hide password',
    [TK.SHOW_PASSWORD]: 'Show password',
    [TK.PREVIOUS_RECIPIENT]: 'Previous recipient',
    [TK.NEXT_RECIPIENT]: 'Next recipient',
    [TK.EDIT_DIALOG_TITLE]: 'make it extra special',
    [TK.EDIT_DIALOG_SUB_TITLE]:
      'Choose any of our special upgrades below to enhance your gift.',
    [TK.EDIT_DIALOG_SUB_TITLE_NO_UPGRADES]:
      'We’re sorry, add-ons aren’t available for this product. Return to cart to continue.',
    [TK.EDIT_CART_DIALOG_TITLE]: 'edit selected product',
    [TK.EDIT_CART_PRODUCT_CODE]: 'Product Code',
    [TK.EDIT_CART_CHOOSE_OPTION]: 'Choose an option',
    [TK.REMOVE_DIALOG_TITLE]: 'Remove From Cart',
    [TK.REMOVE_DIALOG_MESSAGE]:
      'Removing this product from your cart will also remove any upgrades and add-ons selected for that product.',
    [TK.REMOVE_DIALOG_BACK]: 'Go Back',
    [TK.REMOVE_DIALOG_CONFIRM]: 'Confirm',
    [TK.GIFTING_EXPERIENCE_TITLE]: 'a one-of-a-kind gifting experience',
    [TK.LEARN_MORE_PACKING]:
      'Learn More about our complimentary gift wrapping below.',
    [TK.GIFTING_EXPERIENCE_SUBTITLE]:
      'Enjoy your treats in the perfect gift box, fit for any occasion',
    [TK.GIFTING_EXPERIENCE_DESCRIPTION]: `Our beautiful, complimentary gift wrapping is included with every edible® order! Whether it's for yourself, a close friend, an inspiring coworker, or a treasured loved one, our gifts are sure to stand out for indulgences and special events.`,
    [TK.PDP_MOTHER_DAY_BANNER_DESCRIPTION_LINK]: 'jeanettagonzales.com',
    [TK.GIFTING_EXPERIENCE_INLINE_SUBTITLE]:
      'about our complimentary gift wrapping below.',
    [TK.GIFTING_EXPERIENCE_LEARN_MORE]: 'Learn more',
    [TK.PDP_HIGHLIGHT_REVIEWS_TITLE]: 'The reviews are in',
    [TK.PDP_MOTHER_DAY_BANNER_TITLE]: 'the art of gifting',
    [TK.PDP_MOTHER_DAY_BANNER_DESCRIPTION]:
      'Introducing our Mother’s Day keepsake collection design by illustrator and artist coach Jeanetta Gonzales. Limited edition pieces that blend creativity and flavor exclusively available at Edible.  To learn more about Jeanetta visit her website at ',
    [TK.DELIVERY_FEE_DISCLAIMER_CA]:
      '* Free delivery applies only to orders over {{fee}} before tax and after discounts. Terms apply. Offer valid on next-day deliveries within Canada.',
    [TK.DELIVERY_FEE_DISCLAIMER_US]:
      '* Free delivery applies only to orders over {{fee}} before tax and after discounts. Terms apply. Offer valid on next-day deliveries within the contiguous U.S. only.',
    [TK.ORDER_CONFIRMATION_TIPPING_NONE]: 'None',
    [TK.GET_IN_THE_KNOW_EMAIL_LABEL]: 'Email Address*',
    [TK.GET_IN_THE_KNOW_PHONE_LABEL]: 'Phone Number',
    [TK.GET_IN_THE_KNOW_DISCLAIMER]:
      '*By completing this form you are signing up to receive our emails and can unsubscribe at any time.',
    [TK.GET_IN_THE_KNOW_AGREE_TERMS]: 'I agree to the',
    [TK.GET_IN_THE_KNOW_TERMS_AND_CONDITIONS]: 'Terms & Conditions',
    [TK.GET_IN_THE_KNOW_TERMS_OF_USE]: 'Terms of Use',
    [TK.GET_IN_THE_KNOW_COMMUNICATIONS_POLICY]: 'Communications Policy',
    [TK.GET_IN_THE_KNOW_SUBMIT_BUTTON]: 'Sign Up',
    [TK.GET_IN_THE_KNOW_SUBMITTING_BUTTON]: 'Signing Up...',
    [TK.GET_IN_THE_KNOW_SUCCESS_TITLE]: 'Thank you for signing up!',
    [TK.GET_IN_THE_KNOW_SUCCESS_MESSAGE]:
      'Check your inbox for exclusive offers and gift ideas.',
    [TK.GET_IN_THE_KNOW_EMAIL_ERROR]: 'Enter a valid email',
    [TK.GET_IN_THE_KNOW_PHONE_ERROR]: 'Enter a valid phone #',
    [TK.SIGN_UP_GRID_GET_IN_THE_KNOW_TITLE]: 'get in the know',
    [TK.SIGN_UP_GRID_GET_IN_THE_KNOW_DESCRIPTION]:
      'All the latest new products, deals, and more, delivered right to your inbox.',
    [TK.GOODY_MARKETING_LANDING_HERO_BANNER_TITLE]: 'something for everyone',
    [TK.GOODY_MARKETING_LANDING_HERO_BANNER_SUBTITLE]:
      'Whether celebrating the in-laws’ anniversary, your brother’s big day, or your bestie’s work promotion, we’ve chased down the latest trends, treats, and tastes perfect for any occasion.',
    [TK.GOODY_MARKETING_LANDING_HERO_BANNER_ITEM_1]:
      'Shop gifts for every occasion',
    [TK.GOODY_MARKETING_LANDING_HERO_BANNER_ITEM_2]:
      'Browse global and gourmet collections',
    [TK.GOODY_MARKETING_LANDING_HERO_BANNER_ITEM_3]:
      'Count on the leaders of gifting for 25 years',
    [TK.GOODY_MARKETING_LANDING_NEED_A_GIFT_NOW]:
      'need a gift? edible arranges everything.',
    [TK.GOODY_MARKETING_LANDING_NEED_A_GIFT_NOW_DESCRIPTION]:
      'After 25+ years hand-crafting and hand-delivering deliciousness, consider us your one-stop-shop for celebrations whenever, wherever.',
    [TK.GOODY_MARKETING_LANDING_SHOP_NOW]: 'Shop Now',
    [TK.GOODY_MARKETING_LANDING_NOW_DELIVERING]:
      'now delivering: the perfect gift',
    [TK.GOODY_MARKETING_LANDING_NOW_DELIVERING_FIRST_ITEM]:
      'Support businesses founded with a cause.',
    [TK.GOODY_MARKETING_LANDING_NOW_DELIVERING_SECOND_ITEM]:
      'Shop by budget, lifestyle, and more from local sources.',
    [TK.GOODY_MARKETING_LANDING_NOW_DELIVERING_DESCRIPTION]:
      'We’ve sourced gifts, thinking-of-you’s, little treats, and more for all of life’s moments, flawlessly delivered.',
    [TK.GOODY_MARKETING_LANDING_PRODUCT_GRID_TITLE]: 'the perfect gift',
    [TK.GOODY_MARKETING_LANDING_PRODUCT_GRID_DESCRIPTION]:
      'We’ve sourced gifts, thinking-of-you’s, little treats, and more for all of life’s moments, flawlessly delivered.',
    [TK.GOODY_MARKETING_LANDING_MARKETPLACE_FAQS]: 'marketplace faqs',
    [TK.SUBSCRIPTION_SUCCESS_POPUP_GOODY_POPUP_GIFT_TEXT]:
      'Your one-stop-shop for celebrations.',
    [TK.SUBSCRIPTION_SUCCESS_POPUP_GOODY_BUTTON_TEXT]: 'Shop Our Marketplace',
    [TK.SUBSCRIPTION_SUCCESS_POPUP_GOODY_DESCRIPTION_LAST]:
      'Thanks for signing up! Check your email inbox for communications from us, soon.',
    [TK.WHO_WE_ARE_TITLE]: 'Who we are',
    [TK.WHO_WE_ARE_SUBTITLE]:
      'At edible®, our passion, heritage, and future are rooted in helping people all over the world celebrate life’s most special moments with a gift or something sweet that’s carefully crafted to wow.',
    [TK.WHO_WE_ARE_FEATURED_ITEM_1_TITLE]: 'delicious delivered',
    [TK.WHO_WE_ARE_FEATURED_ITEM_1_DESCRIPTION]:
      'Celebrate anytime from anywhere.',
    [TK.WHO_WE_ARE_FEATURED_ITEM_2_TITLE]: 'The original',
    [TK.WHO_WE_ARE_FEATURED_ITEM_2_DESCRIPTION]:
      'Your industry-first fruit arrangement since 1999.',
    [TK.WHO_WE_ARE_FEATURED_ITEM_3_TITLE]: 'Champions of celebration',
    [TK.WHO_WE_ARE_FEATURED_ITEM_3_DESCRIPTION]:
      'Everything to celebrate every moment.',
    [TK.WHO_WE_ARE_FEATURED_ITEM_4_TITLE]: 'Excellence insured',
    [TK.WHO_WE_ARE_FEATURED_ITEM_4_DESCRIPTION]:
      'Hand-crafted, gift-wrapped, and hand-delivered.',
    [TK.WHO_WE_ARE_FEATURED_ITEM_5_TITLE]: 'The edible guarantee',
    [TK.WHO_WE_ARE_FEATURED_ITEM_5_DESCRIPTION]:
      'Delivery beyond doorsteps, guaranteed.',
    [TK.WHO_WE_ARE_OUR_MISSION_TITLE]: 'our mission',
    [TK.WHO_WE_ARE_OUR_MISSION_SUBTITLE]: 'is simply to WOW you!®',
    [TK.WHO_WE_ARE_OUR_MISSION_DESCRIPTION]:
      'This hope is what drives us to deliver delicious and make more moments matter. It’s the reason we spend years developing each unique fruit concept, ensure that every piece of produce meets our standards, and have each arrangement crafted with love and attention to detail. Just like our delightful, fresh, and fruity treats and sweets, we believe in putting our mission where our mouth is.',
    [TK.WHO_WE_ARE_OUR_MISSION_BUTTON_TEXT]: 'Learn More',
    [TK.WHO_WE_ARE_HISTORY_BEGINNING_TITLE]: 'our beginning',
    [TK.WHO_WE_ARE_HISTORY_BEGINNING_DESCRIPTION]:
      'In 1999, Tariq Farid launched the first Edible Arrangements store in Connecticut, which quickly caught on and became a cultural phenomenon. Growing to hundreds of primarily franchised, locally owned and operated locations across the US and Canada, with the ability to hand deliver within one hour, Edible became widely known for being a creative gifting solution.',
    [TK.WHO_WE_ARE_HISTORY_FUTURE_TITLE]: 'our future',
    [TK.WHO_WE_ARE_HISTORY_FUTURE_DESCRIPTION]:
      'Next-gen Edible® is all kinds of deliciousness delivered right when you need it. From mouth-watering brownies and cupcakes to show-stopping dessert boards and fresh flowers, today’s Edible is more than just our stunning arrangements – it’s the next generation of gifting and treating, hand-crafted to wow.',
    [TK.WHO_WE_ARE_HISTORY_TITLE]: 'history in the making',
    [TK.WHO_WE_ARE_HISTORY_BUTTON_TEXT]: 'Find Your Store',
    [TK.WHO_WE_ARE_TREATS_TITLE]: 'shop the treats that made us famous',
    [TK.WHO_WE_ARE_LEADERSHIP_TITLE]: 'leadership',
    [TK.WHO_WE_ARE_LEADERSHIP_FOUNDER_TITLE]: 'founder',
    [TK.WHO_WE_ARE_LEADERSHIP_FOUNDER_DESCRIPTION_ONE]:
      'Tariq Farid, the Founder and Chairman of Edible. Embarking on an extraordinary journey from Pakistan to America at the age of 11, Tariq Farid’s story is a testament to the American dream. Growing up in West Haven, Connecticut, he developed an early affinity for entrepreneurship. Tariq’s journey unfolded at a local McDonald’s, where he discovered the transformative power of business systemization.',
    [TK.WHO_WE_ARE_LEADERSHIP_FOUNDER_DESCRIPTION_TWO]:
      'In a bold move at 17, armed with a $5,000 loan from family and friends, Tariq purchased a flower shop in East Haven, Connecticut, to open the first Edible Arrangements (now Edible) store in 1999. Within two years, he transformed a single store into four. The venture swiftly evolved into a flourishing franchise empire, with hundreds of stores worldwide.',
    [TK.WHO_WE_ARE_LEADERSHIP_FOUNDER_DESCRIPTION_THREE]:
      'Tariq’s strategic acumen not only shaped the company’s trajectory but also led him to found Netsolace® in 2001, a software platform offering cutting-edge technology solutions for franchise companies, including Edible. Growing the Edible ecosystem in 2003, he went on to found BerryDirect®, a global supply chain service provider offering reliable global sourcing, fulfillment services, and high-quality products.',
    [TK.WHO_WE_ARE_LEADERSHIP_FOUNDER_DESCRIPTION_FOUR]:
      'Beyond the boardroom, Tariq’s commitment to philanthropy is equally remarkable. In 2013, he established the Tariq Farid Foundation, channeling nearly $1 million annually to causes worldwide, ranging from healthcare and education to supporting refugees and fighting childhood cancer. His commitment to giving back through his foundation reflects his dedication to making a positive difference in the lives of others.',
    [TK.WHO_WE_ARE_LEADERSHIP_CEO_TITLE]: 'ceo',
    [TK.WHO_WE_ARE_LEADERSHIP_CEO_DESCRIPTION_ONE]:
      'Somia Farid Silber serves as the Chief Executive Officer of Edible Brands, a role she assumed in October 2024 after a transformative tenure as President. As CEO, Somia is dedicated to guiding her family-owned business into its next phase of creativity and expansion, steering the strategic direction for Edible Brands and its subsidiaries, Edible Arrangements®, Roti Modern Mediterranean®, edibles.com™, Netsolace® and BerryDirect®, with a focus on innovation, culture and growth.',
    [TK.WHO_WE_ARE_LEADERSHIP_CEO_DESCRIPTION_TWO]:
      'During her time as President, Somia built a world-class executive team and redefined Edible’s brand identity across its digital and physical platforms. She led the development of Edible Arrangement’s Next Gen retail stores, now under construction in key markets, which will deliver a more personalized and immersive gifting experience. Somia also expanded the company’s e-commerce capabilities by introducing a one-hour delivery guarantee available to nearly 70% of households in the U.S. and partnering with services like DoorDash and Uber Eats. As CEO, Somia continues to drive this innovation, ensuring growth across Edible’s core consumer brands and subsidiaries.',
    [TK.WHO_WE_ARE_LEADERSHIP_CEO_DESCRIPTION_THREE]:
      'Somia’s journey to this role is marked by a personal history with the brand and years of dedication and innovation within the company since joining full-time in 2016. Her prior experience as Vice President of eCommerce and General Manager of Netsolace, Edible’s technology arm, was instrumental in driving digital transformation and operational excellence. In 2024, Silber was named one of Georgia’s top 100 C-level executives by Titan 100. She was also recognized as one of the “100 Influential Women in Franchising: Ones to Watch” by What Franchise Magazine in 2020 and as one of the top 40 retail professionals under 40 by Retail TouchPoints and design: retail in 2021.',
    [TK.WHO_WE_ARE_LEADERSHIP_CEO_DESCRIPTION_FOUR]:
      'Somia holds a bachelor’s degree in business administration from Babson College and has served on its Board of Trustees since 2021. Outside of her professional life, she enjoys traveling, trying new restaurants in town, and spending time with her family.',
    [TK.WHO_WE_ARE_LEADERSHIP_VIEW_MORE]: 'View More',
    [TK.WHO_WE_ARE_LEADERSHIP_VIEW_LESS]: 'View Less',
    [TK.WHO_WE_ARE_GUARANTEE_TITLE]: 'We’re devoted to the edible guarantee',
    [TK.WHO_WE_ARE_GUARANTEE_DESCRIPTION]:
      'Your happiness is our happiness, and it’s 100% guaranteed.',
    [TK.WHO_WE_ARE_GUARANTEE_BUTTON_TEXT]: 'Learn More',
    [TK.WHO_WE_ARE_QUOTE_TEXT]:
      "We're not just in the gift-giving business, we're in the business of celebrating life.",
    [TK.WHO_WE_ARE_AWARDS_AND_ACHIEVEMENTS_TITLE]:
      'our awards and achievements',
    [TK.WHO_WE_ARE_AWARDS_AND_ACHIEVEMENTS_DESCRIPTION]:
      'We are honored and humbled to receive each award and recognition for our achievements and excellence in our businesses and industries. Check out our latest accolades here.',
    [TK.WHO_WE_ARE_AWARDS_AND_ACHIEVEMENTS_BUTTON_TEXT]: 'Press Page',
    [TK.WHO_WE_ARE_AWARDS_AND_ACHIEVEMENTS_AWARD_1_TITLE]:
      '"Fastest-Growing Company Streak"',
    [TK.WHO_WE_ARE_AWARDS_AND_ACHIEVEMENTS_AWARD_1_DESCRIPTION]:
      'Edible Arrangements was ranked among the fastest-growing private companies in America by Inc. magazine for 11 consecutive years, from 2005 to 2015.',
    [TK.WHO_WE_ARE_AWARDS_AND_ACHIEVEMENTS_AWARD_2_TITLE]:
      'Franchise Times Top 200+',
    [TK.WHO_WE_ARE_AWARDS_AND_ACHIEVEMENTS_AWARD_2_DESCRIPTION]:
      'Edible Arrangements and Naranga were ranked among the top 200+ largest franchise systems in the world by Franchise Times magazine in 2020.',
    [TK.WHO_WE_ARE_AWARDS_AND_ACHIEVEMENTS_AWARD_3_TITLE]:
      'Forbes Best Employers For Diversity',
    [TK.WHO_WE_ARE_AWARDS_AND_ACHIEVEMENTS_AWARD_3_DESCRIPTION]:
      'Edible Arrangements was ranked among the fastest-growing private companies in America by Inc. magazine for 11 years, from 2005 to 2015.',
    [TK.WHO_WE_ARE_AWARDS_AND_ACHIEVEMENTS_AWARD_4_TITLE]:
      'On the Internet Retailer 2013',
    [TK.WHO_WE_ARE_AWARDS_AND_ACHIEVEMENTS_AWARD_4_DESCRIPTION]:
      'Edible Edible Arrangements was ranked among the fastest-growing private companies in America by Inc. magazine for 11 consecutive years, from 2005 to 2015.',
    [TK.WHO_WE_ARE_CAREERS_TITLE]: 'careers',
    [TK.WHO_WE_ARE_CAREERS_DESCRIPTION]:
      'Want to join our team? Browse all our open positions.',
    [TK.WHO_WE_ARE_CAREERS_BUTTON_TEXT_ONE]: 'View Store Openings',
    [TK.WHO_WE_ARE_CAREERS_BUTTON_TEXT_TWO]: 'View Corporate Openings',
    [TK.WHO_WE_ARE_PRODUCT_CAROUSEL_TITLE]: 'shop trending treats',
    [TK.WHO_WE_ARE_PRODUCT_CAROUSEL_BUTTON_TEXT]: 'See What’s Hot',
    [TK.CATERING_DISCLAIMER]:
      'All orders require a minimum of one business day for processing. Catering orders do not qualify for same-day fulfillment.',
    [TK.CATERING_UTENSILS_DISCLAIMER]:
      'Utensils and serving ware are not included with catering orders.',
    [TK.CATERING_ADD_TO_CART_BUTTON]: 'Add To Cart',
    [TK.CATERING_COLLECTION]: 'Our Collection',
    [TK.CATERING_COLLECTION_SUBTEXT]:
      'Edible’s fruit arrangements and fruit baskets are perfect for any special occasion. From affordable fruit baskets to delivery and pick-up options, shop the entire collection here!',
    [TK.CATERING_VIEW_MORE]: 'view more details',
    [TK.CATERING_VIEW_LESS]: 'view less details',
    [TK.CATERING_SHOW_TEXT]: 'Showing',
    [TK.CATERING_OF_TEXT]: 'of',
    [TK.CATERING_RESULTS_TEXT]: 'Results',
    [TK.CATERING_SORT_TEXT]: 'Sort By',
    [TK.CATERING_BACK]: 'Back',
    [TK.CATERING_ERROR_404_OOPS]: 'oops-a-pineapple daisy',
    [TK.CATERING_ERROR_404_TEXT]:
      'We couldn’t find available products for your event. Try updating your event details or filters to discover more products.',
    [TK.CATERING_ERROR_404_UPDATE]: 'Update Event Details',
    [TK.CATERING_ERROR_404_CLEAR]: 'Clear Filters',
    [TK.CATERING_FAQ_TEXT]: 'FAQs about Fruit arrangements',
    [TK.CATERING_CAROUSEL_TITLE]: 'top sellers',
    [TK.CATERING_TEXT]: 'Catering',
    [TK.CATERING_MENU]: 'Menu',
    [TK.CATERING_DELIVERY_HEADING]: 'Who should the driver ask for?',
    [TK.CATERING_PICKUP_HEADING]: 'Who is picking up this order?',
    [TK.PICKUP_FROM]: 'Pickup Time',
    [TK.ZIP_USA_ERROR]: 'Postal code not found in Canada.',
    [TK.ZIP_USA_ERROR_SUB]: 'Did you mean to enter a US zip code?',
    [TK.SHOP_EDIBLE_US]: 'Shop Edible US',
    [TK.STORE_FINDER_SEARCH_LABEL]: 'Search city and state or zip',
    [TK.CATERING_HEADER_DELIVERY]: 'event details',
    [TK.PICKUP_FROM_FOR_STORE]: 'Pickup From:',
    [TK.CATERING_CONTACT_DETAILS]:
      'We only contact the recipient if there are delivery complications',
    [TK.CATERING_CONTACTS_EMAIL_LABEL]: 'Recipient Email',
    [TK.CATERING_DELIVERY_DETAILS]: 'Delivery details',
    [TK.DELIVERY_FROM_STORE]: 'Delivering from:',
    [TK.CATERING_DELIVERY_DATE]: 'Delivery date:',
    [TK.CATERING_DELIVERY_TIME]: 'Delivery time*',
    [TK.CATERING_DELIVERY_CHOICE]: 'Please choose',
    [TK.CATERING_DELIVERY_FREE]: 'FREE',
    [TK.CATERING_DELIVERY_UNLOCKED]: 'delivery unlocked!',
    [TK.CATERING_EVENT_ADDRESS]: 'Event address',
    [TK.DELIVERY_TIME_SELECT]: 'Please select a delivery time',
    [TK.CATERING_SIZE_TEXT]: 'Size',
    [TK.SELECT_SIZE_TEXT]: 'Select Size:',
    [TK.RECIPIENT_INFORMATION_ERROR_PICKUP_TIME]: 'Select Pickup Time',
    [TK.REFRESH_TITLE]: 'are you sure?',
    [TK.REFRESH_MESSAGE_WITH_CART]:
      'Refreshing the page will reset your event details, disable your cart and remove your items. Would you like to continue?',
    [TK.REFRESH_MESSAGE_WITHOUT_CART]:
      'Refreshing the page will reset your event details. Would you like to continue?',
    [TK.REFRESH_YES]: 'Yes, Refresh',
    [TK.REFRESH_CANCEL]: 'No, Cancel',
  },
};
